"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Dock Scheduling (Beta)
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.3.14
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipwellUiApi = exports.ShipwellUiApiFactory = exports.ShipwellUiApiFp = exports.ShipwellUiApiAxiosParamCreator = exports.HolidaysApi = exports.HolidaysApiFactory = exports.HolidaysApiFp = exports.HolidaysApiAxiosParamCreator = exports.FacilitiesApi = exports.FacilitiesApiFactory = exports.FacilitiesApiFp = exports.FacilitiesApiAxiosParamCreator = exports.AppointmentsApi = exports.AppointmentsApiFactory = exports.AppointmentsApiFp = exports.AppointmentsApiAxiosParamCreator = exports.TemperatureUnitEnum = exports.StandardHolidays = exports.ShipmentMatchingIncludeParams = exports.ShipmentAvailabilityRequestRequestCriteriaTypeEnum = exports.ShipmentAppointmentScheduledResourceResourceTypeEnum = exports.ScheduledResourceTypeEnum = exports.ReferenceQualifierEnum = exports.PackagingTypes = exports.NoCriteriaAvailabilityRequestRequestCriteriaTypeEnum = exports.LocationTypes = exports.FreightAppointmentScheduledResourceResourceTypeEnum = exports.FreightAppointmentAvailabilityRequestRequestCriteriaTypeEnum = exports.FacilityServices = exports.FacilityPointOfContactRole = exports.FacilityIncludeQueryOptionEnum = exports.FacilityDocumentTypeEnum = exports.FacilityAppointmentType = exports.DockSchedulingModeEnum = exports.DockSchedulingEquipmentTypeEnum = exports.DockSchedulingAccessorialTypeEnum = exports.DeliveryTypeEnum = exports.DaysOfWeek = exports.AvailabilityIncludeParams = exports.AppointmentStatusEnum = exports.AppointmentReason = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.AppointmentReason = {
    PreLoad: 'PRE_LOAD',
    Maintenance: 'MAINTENANCE',
    Freight: 'FREIGHT',
    Staging: 'STAGING',
    Other: 'OTHER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.AppointmentStatusEnum = {
    Unscheduled: 'UNSCHEDULED',
    Scheduled: 'SCHEDULED',
    Rescheduled: 'RESCHEDULED',
    Cancelled: 'CANCELLED',
    Arrived: 'ARRIVED',
    ArrivedLate: 'ARRIVED_LATE',
    Delayed: 'DELAYED',
    DockInUse: 'DOCK_IN_USE',
    Rejected: 'REJECTED',
    NoShow: 'NO_SHOW',
    Completed: 'COMPLETED',
    DockIsReady: 'DOCK_IS_READY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.AvailabilityIncludeParams = {
    BestMatchedLoadType: 'load_type_dock_rule_match_results.best_matched_load_type',
    AllMatchedDockRules: 'load_type_dock_rule_match_results.all_matched_dock_rules'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DaysOfWeek = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DeliveryTypeEnum = {
    Receiving: 'RECEIVING',
    Shipping: 'SHIPPING'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DockSchedulingAccessorialTypeEnum = {
    Fork: 'FORK',
    LiftGate: 'LIFT_GATE',
    Pjack: 'PJACK',
    Tarp: 'TARP',
    Hazm: 'HAZM',
    Dolly: 'DOLLY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DockSchedulingEquipmentTypeEnum = {
    DryVan: 'DRY_VAN',
    Reefer: 'REEFER',
    Flatbed: 'FLATBED',
    Container: 'CONTAINER',
    Autohauler: 'AUTOHAULER',
    Bulk: 'BULK',
    Tanker: 'TANKER',
    CurtainSide: 'CURTAIN_SIDE',
    Hopper: 'HOPPER',
    DropDeck: 'DROP_DECK',
    Other: 'OTHER',
    Tilt: 'TILT',
    ContainerInsulated: 'CONTAINER_INSULATED',
    Conestoga: 'CONESTOGA',
    FlatbedConestoga: 'FLATBED_CONESTOGA',
    StepdeckConestoga: 'STEPDECK_CONESTOGA',
    ContainerRefrigerated: 'CONTAINER_REFRIGERATED',
    BTrain: 'B_TRAIN',
    DoubleDrop: 'DOUBLE_DROP',
    DropDeckLandoll: 'DROP_DECK_LANDOLL',
    DumpTrailer: 'DUMP_TRAILER',
    FlatbedHotshot: 'FLATBED_HOTSHOT',
    FlatbedMaxi: 'FLATBED_MAXI',
    Lowboy: 'LOWBOY',
    LowboyOverdimension: 'LOWBOY_OVERDIMENSION',
    RemovableGooseneck: 'REMOVABLE_GOOSENECK',
    StretchTrailer: 'STRETCH_TRAILER',
    TruckAndTrailer: 'TRUCK_AND_TRAILER',
    StepDeck: 'STEP_DECK',
    HopperBottom: 'HOPPER_BOTTOM',
    Pneumatic: 'PNEUMATIC',
    Flatbed53Foot: 'FLATBED_53_FOOT',
    FlatbedAirRide: 'FLATBED_AIR_RIDE',
    FlatbedDouble: 'FLATBED_DOUBLE',
    FlatbedOverdimension: 'FLATBED_OVERDIMENSION',
    AutoCarrier: 'AUTO_CARRIER',
    Conveyor: 'CONVEYOR',
    PowerOnly: 'POWER_ONLY',
    StraightBoxTruck: 'STRAIGHT_BOX_TRUCK',
    InsulatedVan: 'INSULATED_VAN',
    ReeferAirRide: 'REEFER_AIR_RIDE',
    ReeferDouble: 'REEFER_DOUBLE',
    ReeferIntermodal: 'REEFER_INTERMODAL',
    TankerAluminum: 'TANKER_ALUMINUM',
    TankerIntermodal: 'TANKER_INTERMODAL',
    TankerSteel: 'TANKER_STEEL',
    MovingVan: 'MOVING_VAN',
    VanDouble: 'VAN_DOUBLE',
    VanInsulated: 'VAN_INSULATED',
    VanIntermodal: 'VAN_INTERMODAL',
    VanOpenTop: 'VAN_OPEN_TOP',
    VanRollerBed: 'VAN_ROLLER_BED',
    VanTriple: 'VAN_TRIPLE',
    VanVented: 'VAN_VENTED',
    VanWithCurtains: 'VAN_WITH_CURTAINS',
    VanAirRide: 'VAN_AIR_RIDE',
    VanSprinter: 'VAN_SPRINTER',
    ContainerBreakBulk: 'CONTAINER_BREAK_BULK',
    ContainerFlatTrack20Foot: 'CONTAINER_FLAT_TRACK_20_FOOT',
    ContainerFlatTrack40Foot: 'CONTAINER_FLAT_TRACK_40_FOOT',
    ContainerHeavyTested20Foot: 'CONTAINER_HEAVY_TESTED_20_FOOT',
    ContainerHighCube20Foot: 'CONTAINER_HIGH_CUBE_20_FOOT',
    ContainerHighCube40Foot: 'CONTAINER_HIGH_CUBE_40_FOOT',
    ContainerOpenTop20Foot: 'CONTAINER_OPEN_TOP_20_FOOT',
    ContainerOpenTop40Foot: 'CONTAINER_OPEN_TOP_40_FOOT',
    ContainerReefer20Foot: 'CONTAINER_REEFER_20_FOOT',
    ContainerReefer40Foot: 'CONTAINER_REEFER_40_FOOT',
    ContainerReeferTank20Foot: 'CONTAINER_REEFER_TANK_20_FOOT',
    ContainerStandard20Foot: 'CONTAINER_STANDARD_20_FOOT',
    ContainerStandard40Foot: 'CONTAINER_STANDARD_40_FOOT',
    ContainerHighCube45Foot: 'CONTAINER_HIGH_CUBE_45_FOOT',
    ContainerIsoTank20Foot: 'CONTAINER_ISO_TANK_20_FOOT',
    ContainerIsoTank24Foot: 'CONTAINER_ISO_TANK_24_FOOT',
    ContainerIsoTank40Foot: 'CONTAINER_ISO_TANK_40_FOOT',
    Container53Foot: 'CONTAINER_53_FOOT',
    ContainerOversize: 'CONTAINER_OVERSIZE',
    MultiCompartment: 'MULTI_COMPARTMENT',
    LiquidBulkTanker: 'LIQUID_BULK_TANKER',
    DryBulkTanker: 'DRY_BULK_TANKER',
    CargoVan: 'CARGO_VAN',
    MiniVan: 'MINI_VAN',
    Sedan: 'SEDAN',
    TboxRailcar: 'TBOX_RAILCAR',
    CryoRailcar: 'CRYO_RAILCAR',
    Driveaway: 'DRIVEAWAY',
    CustomerPickup: 'CUSTOMER_PICKUP',
    DropTrailer: 'DROP_TRAILER',
    AutoRackBiLevel: 'AUTO_RACK_BI_LEVEL',
    AutoRackTriLevel: 'AUTO_RACK_TRI_LEVEL',
    AutoMax: 'AUTO_MAX',
    Boxcar: 'BOXCAR',
    BulkheadFlatcar: 'BULKHEAD_FLATCAR',
    CenterbeamFlatcar: 'CENTERBEAM_FLATCAR',
    ChainTieDownFlatcar: 'CHAIN_TIE_DOWN_FLATCAR',
    CoalCar: 'COAL_CAR',
    CoilSteelRailcar: 'COIL_STEEL_RAILCAR',
    CoveredCoilRailcar: 'COVERED_COIL_RAILCAR',
    CoveredHopper: 'COVERED_HOPPER',
    Gondola: 'GONDOLA',
    OpenTopHopper: 'OPEN_TOP_HOPPER',
    PipeFlatcar: 'PIPE_FLATCAR',
    RefrigeratedBoxcar: 'REFRIGERATED_BOXCAR',
    TempControlledTrailer: 'TEMP_CONTROLLED_TRAILER',
    Trailer: 'TRAILER',
    HalfTonTruck: 'HALF_TON_TRUCK',
    OneTonTruck: 'ONE_TON_TRUCK',
    MiniFloatTrailerAndTruck: 'MINI_FLOAT_TRAILER_AND_TRUCK',
    Towing: 'TOWING',
    Conestoga48: 'CONESTOGA_48',
    Conestoga53: 'CONESTOGA_53',
    FlatbedConestoga48: 'FLATBED_CONESTOGA_48',
    FlatbedConestoga53: 'FLATBED_CONESTOGA_53',
    StepdeckConestoga48: 'STEPDECK_CONESTOGA_48',
    StepdeckConestoga53: 'STEPDECK_CONESTOGA_53',
    CoFlatbed: 'CO_FLATBED',
    CoStakeBed: 'CO_STAKE_BED',
    Tiltbed48Wench: 'TILTBED_48_WENCH',
    WreckerTiltbed: 'WRECKER_TILTBED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DockSchedulingModeEnum = {
    Ftl: 'FTL',
    Ltl: 'LTL',
    Vltl: 'VLTL',
    Drayage: 'DRAYAGE',
    Parcel: 'PARCEL',
    Intermodal: 'INTERMODAL',
    RailCar: 'RAIL_CAR'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FacilityAppointmentType = {
    ByAppointmentOnly: 'BY_APPOINTMENT_ONLY',
    FirstComeFirstServe: 'FIRST_COME_FIRST_SERVE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FacilityDocumentTypeEnum = {
    Map: 'MAP',
    Other: 'OTHER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FacilityIncludeQueryOptionEnum = {
    Docks: 'DOCKS',
    DockCount: 'DOCK_COUNT',
    ContactCount: 'CONTACT_COUNT',
    LoadTypeCount: 'LOAD_TYPE_COUNT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FacilityPointOfContactRole = {
    Admin: 'ADMIN',
    DockWorker: 'DOCK_WORKER',
    DockSupervisor: 'DOCK_SUPERVISOR',
    GateSecurity: 'GATE_SECURITY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FacilityServices = {
    Restrooms: 'RESTROOMS',
    OvernightParking: 'OVERNIGHT_PARKING',
    InteriorParking: 'INTERIOR_PARKING',
    ExteriorParking: 'EXTERIOR_PARKING',
    LoungeArea: 'LOUNGE_AREA',
    Wifi: 'WIFI',
    Food: 'FOOD',
    Security: 'SECURITY',
    Spanish: 'SPANISH'
};
exports.FreightAppointmentAvailabilityRequestRequestCriteriaTypeEnum = {
    Appointment: 'FREIGHT_APPOINTMENT',
    General: 'FREIGHT_GENERAL'
};
exports.FreightAppointmentScheduledResourceResourceTypeEnum = {
    Appointment: 'FREIGHT_APPOINTMENT',
    General: 'FREIGHT_GENERAL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.LocationTypes = {
    Airport: 'AIRPORT',
    BusinessWithDockOrForklift: 'BUSINESS_WITH_DOCK_OR_FORKLIFT',
    BusinessWithoutDockOrForklift: 'BUSINESS_WITHOUT_DOCK_OR_FORKLIFT',
    CommercialFarmRanchMarina: 'COMMERCIAL_FARM_RANCH_MARINA',
    ConstructionSite: 'CONSTRUCTION_SITE',
    GovernmentLocation: 'GOVERNMENT_LOCATION',
    MilitaryBase: 'MILITARY_BASE',
    OtherSecuredOrLimitedAccessLocation: 'OTHER_SECURED_OR_LIMITED_ACCESS_LOCATION',
    ReligiousInstitution: 'RELIGIOUS_INSTITUTION',
    ResidenceHomeBusiness: 'RESIDENCE_HOME_BUSINESS',
    RestaurantHotelGolfCoursePark: 'RESTAURANT_HOTEL_GOLF_COURSE_PARK',
    SchoolCollege: 'SCHOOL_COLLEGE',
    SelfMiniStorageFacility: 'SELF_MINI_STORAGE_FACILITY',
    Terminal: 'TERMINAL',
    TradeShowConventionCenter: 'TRADE_SHOW_CONVENTION_CENTER'
};
exports.NoCriteriaAvailabilityRequestRequestCriteriaTypeEnum = {
    NoCriteria: 'NO_CRITERIA'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.PackagingTypes = {
    Plt: 'PLT',
    Pkg: 'PKG',
    FloorLoaded: 'FLOOR_LOADED',
    Bag: 'BAG',
    Bale: 'BALE',
    Bin: 'BIN',
    Box: 'BOX',
    Bucket: 'BUCKET',
    Pail: 'PAIL',
    Bundle: 'BUNDLE',
    Can: 'CAN',
    Carton: 'CARTON',
    Case: 'CASE',
    Coil: 'COIL',
    Crate: 'CRATE',
    Cylinder: 'CYLINDER',
    Drum: 'DRUM',
    Package: 'PACKAGE',
    Pieces: 'PIECES',
    Reel: 'REEL',
    Roll: 'ROLL',
    Skid: 'SKID',
    Tube: 'TUBE',
    ToteBin: 'TOTE_BIN',
    ToteCan: 'TOTE_CAN',
    Unit: 'UNIT',
    Other: 'OTHER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ReferenceQualifierEnum = {
    PoNumber: 'PO_NUMBER',
    BolNumber: 'BOL_NUMBER',
    ProNumber: 'PRO_NUMBER',
    CustomerReferenceNumber: 'CUSTOMER_REFERENCE_NUMBER',
    ShipmentReferenceId: 'SHIPMENT_REFERENCE_ID'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ScheduledResourceTypeEnum = {
    FreightAppointment: 'FREIGHT_APPOINTMENT',
    FreightGeneral: 'FREIGHT_GENERAL',
    Shipment: 'SHIPMENT',
    Service: 'SERVICE',
    Leg: 'LEG'
};
exports.ShipmentAppointmentScheduledResourceResourceTypeEnum = {
    Shipment: 'SHIPMENT'
};
exports.ShipmentAvailabilityRequestRequestCriteriaTypeEnum = {
    Shipment: 'SHIPMENT'
};
/**
 * Optional fields to expand when rendering shipment match results
 * @export
 * @enum {string}
 */
exports.ShipmentMatchingIncludeParams = {
    AllMatchedDockRules: 'all_matched_dock_rules',
    BestMatchedLoadType: 'best_matched_load_type'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.StandardHolidays = {
    NewYearsDay: 'NEW_YEARS_DAY',
    MartinLutherKingJrDay: 'MARTIN_LUTHER_KING_JR_DAY',
    PresidentsDay: 'PRESIDENTS_DAY',
    GoodFriday: 'GOOD_FRIDAY',
    MemorialDay: 'MEMORIAL_DAY',
    Juneteenth: 'JUNETEENTH',
    IndependenceDay: 'INDEPENDENCE_DAY',
    LaborDay: 'LABOR_DAY',
    Thanksgiving: 'THANKSGIVING',
    ChristmasDay: 'CHRISTMAS_DAY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TemperatureUnitEnum = {
    C: 'C',
    F: 'F'
};
/**
 * AppointmentsApi - axios parameter creator
 * @export
 */
var AppointmentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Cancel an Appointment
         * @summary Cancel Appointment
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentFacilitiesAppointmentsAppointmentIdCancelPost: function (appointmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'appointmentId' is not null or undefined
                            (0, common_1.assertParamExists)('cancelAppointmentFacilitiesAppointmentsAppointmentIdCancelPost', 'appointmentId', appointmentId);
                            localVarPath = "/facilities/appointments/{appointment_id}/cancel"
                                .replace("{".concat("appointment_id", "}"), encodeURIComponent(String(appointmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Check in an Appointment
         * @summary Check In Appointment
         * @param {string} appointmentId
         * @param {AppointmentCheckInRequest} appointmentCheckInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInAppointmentFacilitiesAppointmentsAppointmentIdCheckInPost: function (appointmentId, appointmentCheckInRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'appointmentId' is not null or undefined
                            (0, common_1.assertParamExists)('checkInAppointmentFacilitiesAppointmentsAppointmentIdCheckInPost', 'appointmentId', appointmentId);
                            // verify required parameter 'appointmentCheckInRequest' is not null or undefined
                            (0, common_1.assertParamExists)('checkInAppointmentFacilitiesAppointmentsAppointmentIdCheckInPost', 'appointmentCheckInRequest', appointmentCheckInRequest);
                            localVarPath = "/facilities/appointments/{appointment_id}/check-in"
                                .replace("{".concat("appointment_id", "}"), encodeURIComponent(String(appointmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appointmentCheckInRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Check out an Appointment
         * @summary Check Out Appointment
         * @param {string} appointmentId
         * @param {AppointmentCheckOutRequest} appointmentCheckOutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutAppointmentFacilitiesAppointmentsAppointmentIdCheckOutPost: function (appointmentId, appointmentCheckOutRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'appointmentId' is not null or undefined
                            (0, common_1.assertParamExists)('checkOutAppointmentFacilitiesAppointmentsAppointmentIdCheckOutPost', 'appointmentId', appointmentId);
                            // verify required parameter 'appointmentCheckOutRequest' is not null or undefined
                            (0, common_1.assertParamExists)('checkOutAppointmentFacilitiesAppointmentsAppointmentIdCheckOutPost', 'appointmentCheckOutRequest', appointmentCheckOutRequest);
                            localVarPath = "/facilities/appointments/{appointment_id}/check-out"
                                .replace("{".concat("appointment_id", "}"), encodeURIComponent(String(appointmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appointmentCheckOutRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create an appointment at a dock.
         * @summary Create Dock Appointment
         * @param {string} facilityId
         * @param {string} dockId
         * @param {CreateAppointment} createAppointment
         * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDockAppointmentFacilitiesFacilityIdDocksDockIdAppointmentsPost: function (facilityId, dockId, createAppointment, overrideAvailabilityRestrictions, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('createDockAppointmentFacilitiesFacilityIdDocksDockIdAppointmentsPost', 'facilityId', facilityId);
                            // verify required parameter 'dockId' is not null or undefined
                            (0, common_1.assertParamExists)('createDockAppointmentFacilitiesFacilityIdDocksDockIdAppointmentsPost', 'dockId', dockId);
                            // verify required parameter 'createAppointment' is not null or undefined
                            (0, common_1.assertParamExists)('createDockAppointmentFacilitiesFacilityIdDocksDockIdAppointmentsPost', 'createAppointment', createAppointment);
                            localVarPath = "/facilities/{facility_id}/docks/{dock_id}/appointments"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)))
                                .replace("{".concat("dock_id", "}"), encodeURIComponent(String(dockId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (overrideAvailabilityRestrictions !== undefined) {
                                localVarQueryParameter['override_availability_restrictions'] = overrideAvailabilityRestrictions;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createAppointment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * List Appointments
         * @summary List All Appointments
         * @param {string} [q] Free-text search across all Appointment reference values
         * @param {AppointmentStatusEnum} [status] Filter for appointments with a specific status
         * @param {string} [plannedDate] Filter for appointments with planned date
         * @param {boolean} [carrierAssigned] Filter for appointments with an assigned carrier
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {string} [facilityId] Filter by only Appointments that take place at this Facility. Results may include both Facility-level Appointments and Dock-level Appointments, but all will take place at the provided Facility.
         * @param {string} [dockId] Filter by only Appointments scheduled at this Dock.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllAppointmentsFacilitiesAppointmentsGet: function (q, status, plannedDate, carrierAssigned, page, limit, sort, facilityId, dockId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/facilities/appointments";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (plannedDate !== undefined) {
                                localVarQueryParameter['planned_date'] = (plannedDate instanceof Date) ?
                                    plannedDate.toISOString().substr(0, 10) :
                                    plannedDate;
                            }
                            if (carrierAssigned !== undefined) {
                                localVarQueryParameter['carrier_assigned'] = carrierAssigned;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (facilityId !== undefined) {
                                localVarQueryParameter['facility_id'] = facilityId;
                            }
                            if (dockId !== undefined) {
                                localVarQueryParameter['dock_id'] = dockId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Reject an Appointment
         * @summary Reject Appointment
         * @param {string} appointmentId
         * @param {AppointmentRejectRequest} appointmentRejectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAppointmentFacilitiesAppointmentsAppointmentIdRejectPost: function (appointmentId, appointmentRejectRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'appointmentId' is not null or undefined
                            (0, common_1.assertParamExists)('rejectAppointmentFacilitiesAppointmentsAppointmentIdRejectPost', 'appointmentId', appointmentId);
                            // verify required parameter 'appointmentRejectRequest' is not null or undefined
                            (0, common_1.assertParamExists)('rejectAppointmentFacilitiesAppointmentsAppointmentIdRejectPost', 'appointmentRejectRequest', appointmentRejectRequest);
                            localVarPath = "/facilities/appointments/{appointment_id}/reject"
                                .replace("{".concat("appointment_id", "}"), encodeURIComponent(String(appointmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appointmentRejectRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Reschedule an Appointment
         * @summary Reschedule Appointment
         * @param {string} appointmentId
         * @param {RescheduleAppointmentRequest} rescheduleAppointmentRequest
         * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleAppointmentFacilitiesAppointmentsAppointmentIdReschedulePost: function (appointmentId, rescheduleAppointmentRequest, overrideAvailabilityRestrictions, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'appointmentId' is not null or undefined
                            (0, common_1.assertParamExists)('rescheduleAppointmentFacilitiesAppointmentsAppointmentIdReschedulePost', 'appointmentId', appointmentId);
                            // verify required parameter 'rescheduleAppointmentRequest' is not null or undefined
                            (0, common_1.assertParamExists)('rescheduleAppointmentFacilitiesAppointmentsAppointmentIdReschedulePost', 'rescheduleAppointmentRequest', rescheduleAppointmentRequest);
                            localVarPath = "/facilities/appointments/{appointment_id}/reschedule"
                                .replace("{".concat("appointment_id", "}"), encodeURIComponent(String(appointmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (overrideAvailabilityRestrictions !== undefined) {
                                localVarQueryParameter['override_availability_restrictions'] = overrideAvailabilityRestrictions;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rescheduleAppointmentRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieve an Appointment by ID
         * @summary Retrieve Appointment
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAppointmentFacilitiesAppointmentsAppointmentIdGet: function (appointmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'appointmentId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveAppointmentFacilitiesAppointmentsAppointmentIdGet', 'appointmentId', appointmentId);
                            localVarPath = "/facilities/appointments/{appointment_id}"
                                .replace("{".concat("appointment_id", "}"), encodeURIComponent(String(appointmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Schedule an unscheduled Appointment
         * @summary Schedule Appointment
         * @param {string} appointmentId
         * @param {ScheduleAppointmentRequest} scheduleAppointmentRequest
         * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleAppointmentFacilitiesAppointmentsAppointmentIdSchedulePost: function (appointmentId, scheduleAppointmentRequest, overrideAvailabilityRestrictions, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'appointmentId' is not null or undefined
                            (0, common_1.assertParamExists)('scheduleAppointmentFacilitiesAppointmentsAppointmentIdSchedulePost', 'appointmentId', appointmentId);
                            // verify required parameter 'scheduleAppointmentRequest' is not null or undefined
                            (0, common_1.assertParamExists)('scheduleAppointmentFacilitiesAppointmentsAppointmentIdSchedulePost', 'scheduleAppointmentRequest', scheduleAppointmentRequest);
                            localVarPath = "/facilities/appointments/{appointment_id}/schedule"
                                .replace("{".concat("appointment_id", "}"), encodeURIComponent(String(appointmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (overrideAvailabilityRestrictions !== undefined) {
                                localVarQueryParameter['override_availability_restrictions'] = overrideAvailabilityRestrictions;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(scheduleAppointmentRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AppointmentsApiAxiosParamCreator = AppointmentsApiAxiosParamCreator;
/**
 * AppointmentsApi - functional programming interface
 * @export
 */
var AppointmentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AppointmentsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Cancel an Appointment
         * @summary Cancel Appointment
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentFacilitiesAppointmentsAppointmentIdCancelPost: function (appointmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cancelAppointmentFacilitiesAppointmentsAppointmentIdCancelPost(appointmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Check in an Appointment
         * @summary Check In Appointment
         * @param {string} appointmentId
         * @param {AppointmentCheckInRequest} appointmentCheckInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInAppointmentFacilitiesAppointmentsAppointmentIdCheckInPost: function (appointmentId, appointmentCheckInRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkInAppointmentFacilitiesAppointmentsAppointmentIdCheckInPost(appointmentId, appointmentCheckInRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Check out an Appointment
         * @summary Check Out Appointment
         * @param {string} appointmentId
         * @param {AppointmentCheckOutRequest} appointmentCheckOutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutAppointmentFacilitiesAppointmentsAppointmentIdCheckOutPost: function (appointmentId, appointmentCheckOutRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkOutAppointmentFacilitiesAppointmentsAppointmentIdCheckOutPost(appointmentId, appointmentCheckOutRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create an appointment at a dock.
         * @summary Create Dock Appointment
         * @param {string} facilityId
         * @param {string} dockId
         * @param {CreateAppointment} createAppointment
         * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDockAppointmentFacilitiesFacilityIdDocksDockIdAppointmentsPost: function (facilityId, dockId, createAppointment, overrideAvailabilityRestrictions, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDockAppointmentFacilitiesFacilityIdDocksDockIdAppointmentsPost(facilityId, dockId, createAppointment, overrideAvailabilityRestrictions, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * List Appointments
         * @summary List All Appointments
         * @param {string} [q] Free-text search across all Appointment reference values
         * @param {AppointmentStatusEnum} [status] Filter for appointments with a specific status
         * @param {string} [plannedDate] Filter for appointments with planned date
         * @param {boolean} [carrierAssigned] Filter for appointments with an assigned carrier
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {string} [facilityId] Filter by only Appointments that take place at this Facility. Results may include both Facility-level Appointments and Dock-level Appointments, but all will take place at the provided Facility.
         * @param {string} [dockId] Filter by only Appointments scheduled at this Dock.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllAppointmentsFacilitiesAppointmentsGet: function (q, status, plannedDate, carrierAssigned, page, limit, sort, facilityId, dockId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listAllAppointmentsFacilitiesAppointmentsGet(q, status, plannedDate, carrierAssigned, page, limit, sort, facilityId, dockId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Reject an Appointment
         * @summary Reject Appointment
         * @param {string} appointmentId
         * @param {AppointmentRejectRequest} appointmentRejectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAppointmentFacilitiesAppointmentsAppointmentIdRejectPost: function (appointmentId, appointmentRejectRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rejectAppointmentFacilitiesAppointmentsAppointmentIdRejectPost(appointmentId, appointmentRejectRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Reschedule an Appointment
         * @summary Reschedule Appointment
         * @param {string} appointmentId
         * @param {RescheduleAppointmentRequest} rescheduleAppointmentRequest
         * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleAppointmentFacilitiesAppointmentsAppointmentIdReschedulePost: function (appointmentId, rescheduleAppointmentRequest, overrideAvailabilityRestrictions, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rescheduleAppointmentFacilitiesAppointmentsAppointmentIdReschedulePost(appointmentId, rescheduleAppointmentRequest, overrideAvailabilityRestrictions, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve an Appointment by ID
         * @summary Retrieve Appointment
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAppointmentFacilitiesAppointmentsAppointmentIdGet: function (appointmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveAppointmentFacilitiesAppointmentsAppointmentIdGet(appointmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Schedule an unscheduled Appointment
         * @summary Schedule Appointment
         * @param {string} appointmentId
         * @param {ScheduleAppointmentRequest} scheduleAppointmentRequest
         * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleAppointmentFacilitiesAppointmentsAppointmentIdSchedulePost: function (appointmentId, scheduleAppointmentRequest, overrideAvailabilityRestrictions, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.scheduleAppointmentFacilitiesAppointmentsAppointmentIdSchedulePost(appointmentId, scheduleAppointmentRequest, overrideAvailabilityRestrictions, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AppointmentsApiFp = AppointmentsApiFp;
/**
 * AppointmentsApi - factory interface
 * @export
 */
var AppointmentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AppointmentsApiFp)(configuration);
    return {
        /**
         * Cancel an Appointment
         * @summary Cancel Appointment
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentFacilitiesAppointmentsAppointmentIdCancelPost: function (appointmentId, options) {
            return localVarFp.cancelAppointmentFacilitiesAppointmentsAppointmentIdCancelPost(appointmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check in an Appointment
         * @summary Check In Appointment
         * @param {string} appointmentId
         * @param {AppointmentCheckInRequest} appointmentCheckInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInAppointmentFacilitiesAppointmentsAppointmentIdCheckInPost: function (appointmentId, appointmentCheckInRequest, options) {
            return localVarFp.checkInAppointmentFacilitiesAppointmentsAppointmentIdCheckInPost(appointmentId, appointmentCheckInRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check out an Appointment
         * @summary Check Out Appointment
         * @param {string} appointmentId
         * @param {AppointmentCheckOutRequest} appointmentCheckOutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutAppointmentFacilitiesAppointmentsAppointmentIdCheckOutPost: function (appointmentId, appointmentCheckOutRequest, options) {
            return localVarFp.checkOutAppointmentFacilitiesAppointmentsAppointmentIdCheckOutPost(appointmentId, appointmentCheckOutRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create an appointment at a dock.
         * @summary Create Dock Appointment
         * @param {string} facilityId
         * @param {string} dockId
         * @param {CreateAppointment} createAppointment
         * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDockAppointmentFacilitiesFacilityIdDocksDockIdAppointmentsPost: function (facilityId, dockId, createAppointment, overrideAvailabilityRestrictions, options) {
            return localVarFp.createDockAppointmentFacilitiesFacilityIdDocksDockIdAppointmentsPost(facilityId, dockId, createAppointment, overrideAvailabilityRestrictions, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List Appointments
         * @summary List All Appointments
         * @param {string} [q] Free-text search across all Appointment reference values
         * @param {AppointmentStatusEnum} [status] Filter for appointments with a specific status
         * @param {string} [plannedDate] Filter for appointments with planned date
         * @param {boolean} [carrierAssigned] Filter for appointments with an assigned carrier
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {string} [facilityId] Filter by only Appointments that take place at this Facility. Results may include both Facility-level Appointments and Dock-level Appointments, but all will take place at the provided Facility.
         * @param {string} [dockId] Filter by only Appointments scheduled at this Dock.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllAppointmentsFacilitiesAppointmentsGet: function (q, status, plannedDate, carrierAssigned, page, limit, sort, facilityId, dockId, options) {
            return localVarFp.listAllAppointmentsFacilitiesAppointmentsGet(q, status, plannedDate, carrierAssigned, page, limit, sort, facilityId, dockId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Reject an Appointment
         * @summary Reject Appointment
         * @param {string} appointmentId
         * @param {AppointmentRejectRequest} appointmentRejectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAppointmentFacilitiesAppointmentsAppointmentIdRejectPost: function (appointmentId, appointmentRejectRequest, options) {
            return localVarFp.rejectAppointmentFacilitiesAppointmentsAppointmentIdRejectPost(appointmentId, appointmentRejectRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Reschedule an Appointment
         * @summary Reschedule Appointment
         * @param {string} appointmentId
         * @param {RescheduleAppointmentRequest} rescheduleAppointmentRequest
         * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleAppointmentFacilitiesAppointmentsAppointmentIdReschedulePost: function (appointmentId, rescheduleAppointmentRequest, overrideAvailabilityRestrictions, options) {
            return localVarFp.rescheduleAppointmentFacilitiesAppointmentsAppointmentIdReschedulePost(appointmentId, rescheduleAppointmentRequest, overrideAvailabilityRestrictions, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve an Appointment by ID
         * @summary Retrieve Appointment
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAppointmentFacilitiesAppointmentsAppointmentIdGet: function (appointmentId, options) {
            return localVarFp.retrieveAppointmentFacilitiesAppointmentsAppointmentIdGet(appointmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Schedule an unscheduled Appointment
         * @summary Schedule Appointment
         * @param {string} appointmentId
         * @param {ScheduleAppointmentRequest} scheduleAppointmentRequest
         * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleAppointmentFacilitiesAppointmentsAppointmentIdSchedulePost: function (appointmentId, scheduleAppointmentRequest, overrideAvailabilityRestrictions, options) {
            return localVarFp.scheduleAppointmentFacilitiesAppointmentsAppointmentIdSchedulePost(appointmentId, scheduleAppointmentRequest, overrideAvailabilityRestrictions, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AppointmentsApiFactory = AppointmentsApiFactory;
/**
 * AppointmentsApi - object-oriented interface
 * @export
 * @class AppointmentsApi
 * @extends {BaseAPI}
 */
var AppointmentsApi = /** @class */ (function (_super) {
    __extends(AppointmentsApi, _super);
    function AppointmentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Cancel an Appointment
     * @summary Cancel Appointment
     * @param {string} appointmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    AppointmentsApi.prototype.cancelAppointmentFacilitiesAppointmentsAppointmentIdCancelPost = function (appointmentId, options) {
        var _this = this;
        return (0, exports.AppointmentsApiFp)(this.configuration).cancelAppointmentFacilitiesAppointmentsAppointmentIdCancelPost(appointmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check in an Appointment
     * @summary Check In Appointment
     * @param {string} appointmentId
     * @param {AppointmentCheckInRequest} appointmentCheckInRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    AppointmentsApi.prototype.checkInAppointmentFacilitiesAppointmentsAppointmentIdCheckInPost = function (appointmentId, appointmentCheckInRequest, options) {
        var _this = this;
        return (0, exports.AppointmentsApiFp)(this.configuration).checkInAppointmentFacilitiesAppointmentsAppointmentIdCheckInPost(appointmentId, appointmentCheckInRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check out an Appointment
     * @summary Check Out Appointment
     * @param {string} appointmentId
     * @param {AppointmentCheckOutRequest} appointmentCheckOutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    AppointmentsApi.prototype.checkOutAppointmentFacilitiesAppointmentsAppointmentIdCheckOutPost = function (appointmentId, appointmentCheckOutRequest, options) {
        var _this = this;
        return (0, exports.AppointmentsApiFp)(this.configuration).checkOutAppointmentFacilitiesAppointmentsAppointmentIdCheckOutPost(appointmentId, appointmentCheckOutRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create an appointment at a dock.
     * @summary Create Dock Appointment
     * @param {string} facilityId
     * @param {string} dockId
     * @param {CreateAppointment} createAppointment
     * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    AppointmentsApi.prototype.createDockAppointmentFacilitiesFacilityIdDocksDockIdAppointmentsPost = function (facilityId, dockId, createAppointment, overrideAvailabilityRestrictions, options) {
        var _this = this;
        return (0, exports.AppointmentsApiFp)(this.configuration).createDockAppointmentFacilitiesFacilityIdDocksDockIdAppointmentsPost(facilityId, dockId, createAppointment, overrideAvailabilityRestrictions, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List Appointments
     * @summary List All Appointments
     * @param {string} [q] Free-text search across all Appointment reference values
     * @param {AppointmentStatusEnum} [status] Filter for appointments with a specific status
     * @param {string} [plannedDate] Filter for appointments with planned date
     * @param {boolean} [carrierAssigned] Filter for appointments with an assigned carrier
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {string} [facilityId] Filter by only Appointments that take place at this Facility. Results may include both Facility-level Appointments and Dock-level Appointments, but all will take place at the provided Facility.
     * @param {string} [dockId] Filter by only Appointments scheduled at this Dock.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    AppointmentsApi.prototype.listAllAppointmentsFacilitiesAppointmentsGet = function (q, status, plannedDate, carrierAssigned, page, limit, sort, facilityId, dockId, options) {
        var _this = this;
        return (0, exports.AppointmentsApiFp)(this.configuration).listAllAppointmentsFacilitiesAppointmentsGet(q, status, plannedDate, carrierAssigned, page, limit, sort, facilityId, dockId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Reject an Appointment
     * @summary Reject Appointment
     * @param {string} appointmentId
     * @param {AppointmentRejectRequest} appointmentRejectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    AppointmentsApi.prototype.rejectAppointmentFacilitiesAppointmentsAppointmentIdRejectPost = function (appointmentId, appointmentRejectRequest, options) {
        var _this = this;
        return (0, exports.AppointmentsApiFp)(this.configuration).rejectAppointmentFacilitiesAppointmentsAppointmentIdRejectPost(appointmentId, appointmentRejectRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Reschedule an Appointment
     * @summary Reschedule Appointment
     * @param {string} appointmentId
     * @param {RescheduleAppointmentRequest} rescheduleAppointmentRequest
     * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    AppointmentsApi.prototype.rescheduleAppointmentFacilitiesAppointmentsAppointmentIdReschedulePost = function (appointmentId, rescheduleAppointmentRequest, overrideAvailabilityRestrictions, options) {
        var _this = this;
        return (0, exports.AppointmentsApiFp)(this.configuration).rescheduleAppointmentFacilitiesAppointmentsAppointmentIdReschedulePost(appointmentId, rescheduleAppointmentRequest, overrideAvailabilityRestrictions, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve an Appointment by ID
     * @summary Retrieve Appointment
     * @param {string} appointmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    AppointmentsApi.prototype.retrieveAppointmentFacilitiesAppointmentsAppointmentIdGet = function (appointmentId, options) {
        var _this = this;
        return (0, exports.AppointmentsApiFp)(this.configuration).retrieveAppointmentFacilitiesAppointmentsAppointmentIdGet(appointmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Schedule an unscheduled Appointment
     * @summary Schedule Appointment
     * @param {string} appointmentId
     * @param {ScheduleAppointmentRequest} scheduleAppointmentRequest
     * @param {boolean} [overrideAvailabilityRestrictions] Bypass any restrictions on appointment scheduling that would normally apply. This allows you to ignore things such as facility hours of operation, holidays, max appointment capacity, etc. Providing a true value for this parameter will fail if the user does not have override permissions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApi
     */
    AppointmentsApi.prototype.scheduleAppointmentFacilitiesAppointmentsAppointmentIdSchedulePost = function (appointmentId, scheduleAppointmentRequest, overrideAvailabilityRestrictions, options) {
        var _this = this;
        return (0, exports.AppointmentsApiFp)(this.configuration).scheduleAppointmentFacilitiesAppointmentsAppointmentIdSchedulePost(appointmentId, scheduleAppointmentRequest, overrideAvailabilityRestrictions, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AppointmentsApi;
}(base_1.BaseAPI));
exports.AppointmentsApi = AppointmentsApi;
/**
 * FacilitiesApi - axios parameter creator
 * @export
 */
var FacilitiesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Update all FacilityHoursOfOperation on a given Facility in one request. This will delete all existing FacilityHoursOfOperation on the Facility, then recreate them according to the data in the request.
         * @summary Bulk Update Hours Of Operation
         * @param {string} facilityId
         * @param {BulkUpdateHoursOfOperationRequest} bulkUpdateHoursOfOperationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateHoursOfOperationFacilitiesFacilityIdHoursOfOperationPatch: function (facilityId, bulkUpdateHoursOfOperationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('bulkUpdateHoursOfOperationFacilitiesFacilityIdHoursOfOperationPatch', 'facilityId', facilityId);
                            // verify required parameter 'bulkUpdateHoursOfOperationRequest' is not null or undefined
                            (0, common_1.assertParamExists)('bulkUpdateHoursOfOperationFacilitiesFacilityIdHoursOfOperationPatch', 'bulkUpdateHoursOfOperationRequest', bulkUpdateHoursOfOperationRequest);
                            localVarPath = "/facilities/{facility_id}/hours-of-operation"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkUpdateHoursOfOperationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a dock at a specified facility.
         * @summary Create Dock
         * @param {string} facilityId
         * @param {CreateFacilityDock} createFacilityDock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDockFacilitiesFacilityIdDocksPost: function (facilityId, createFacilityDock, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('createDockFacilitiesFacilityIdDocksPost', 'facilityId', facilityId);
                            // verify required parameter 'createFacilityDock' is not null or undefined
                            (0, common_1.assertParamExists)('createDockFacilitiesFacilityIdDocksPost', 'createFacilityDock', createFacilityDock);
                            localVarPath = "/facilities/{facility_id}/docks"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFacilityDock, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a dock appointment rule at a specified facility.
         * @summary Create Facility Dock Appointment Rule
         * @param {string} facilityId
         * @param {string} dockId
         * @param {CreateFacilityDockAppointmentRule} createFacilityDockAppointmentRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesPost: function (facilityId, dockId, createFacilityDockAppointmentRule, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesPost', 'facilityId', facilityId);
                            // verify required parameter 'dockId' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesPost', 'dockId', dockId);
                            // verify required parameter 'createFacilityDockAppointmentRule' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesPost', 'createFacilityDockAppointmentRule', createFacilityDockAppointmentRule);
                            localVarPath = "/facilities/{facility_id}/docks/{dock_id}/rules"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)))
                                .replace("{".concat("dock_id", "}"), encodeURIComponent(String(dockId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFacilityDockAppointmentRule, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Upload a document at a specified facility.
         * @summary Create Facility Document
         * @param {string} facilityId
         * @param {File} file
         * @param {string} [documentType]
         * @param {string} [description]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityDocumentFacilitiesFacilityIdDocumentsPost: function (facilityId, file, documentType, description, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityDocumentFacilitiesFacilityIdDocumentsPost', 'facilityId', facilityId);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityDocumentFacilitiesFacilityIdDocumentsPost', 'file', file);
                            localVarPath = "/facilities/{facility_id}/documents"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (documentType !== undefined) {
                                localVarFormParams.append('document_type', documentType);
                            }
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a facility.
         * @summary Create Facility
         * @param {CreateFacility} createFacility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityFacilitiesPost: function (createFacility, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createFacility' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityFacilitiesPost', 'createFacility', createFacility);
                            localVarPath = "/facilities";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFacility, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a holiday at a facility.
         * @summary Create Facility Holiday
         * @param {string} facilityId
         * @param {CreateFacilityHoliday} createFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityHolidayFacilitiesFacilityIdHolidaysPost: function (facilityId, createFacilityHoliday, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityHolidayFacilitiesFacilityIdHolidaysPost', 'facilityId', facilityId);
                            // verify required parameter 'createFacilityHoliday' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityHolidayFacilitiesFacilityIdHolidaysPost', 'createFacilityHoliday', createFacilityHoliday);
                            localVarPath = "/facilities/{facility_id}/holidays"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFacilityHoliday, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a load type.
         * @summary Create Facility Load Type
         * @param {string} facilityId
         * @param {CreateLoadType} createLoadType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityLoadTypeFacilitiesFacilityIdLoadTypesPost: function (facilityId, createLoadType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityLoadTypeFacilitiesFacilityIdLoadTypesPost', 'facilityId', facilityId);
                            // verify required parameter 'createLoadType' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityLoadTypeFacilitiesFacilityIdLoadTypesPost', 'createLoadType', createLoadType);
                            localVarPath = "/facilities/{facility_id}/load-types"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createLoadType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create hours of operation at a specified facility.
         * @summary Create Hours Of Operation
         * @param {string} facilityId
         * @param {CreateFacilityHoursOfOperation} createFacilityHoursOfOperation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHoursOfOperationFacilitiesFacilityIdHoursOfOperationPost: function (facilityId, createFacilityHoursOfOperation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('createHoursOfOperationFacilitiesFacilityIdHoursOfOperationPost', 'facilityId', facilityId);
                            // verify required parameter 'createFacilityHoursOfOperation' is not null or undefined
                            (0, common_1.assertParamExists)('createHoursOfOperationFacilitiesFacilityIdHoursOfOperationPost', 'createFacilityHoursOfOperation', createFacilityHoursOfOperation);
                            localVarPath = "/facilities/{facility_id}/hours-of-operation"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFacilityHoursOfOperation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a point of contact at a specified facility.
         * @summary Create Point Of Contact
         * @param {string} facilityId
         * @param {CreateFacilityPointOfContact} createFacilityPointOfContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPointOfContactFacilitiesFacilityIdPointOfContactsPost: function (facilityId, createFacilityPointOfContact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('createPointOfContactFacilitiesFacilityIdPointOfContactsPost', 'facilityId', facilityId);
                            // verify required parameter 'createFacilityPointOfContact' is not null or undefined
                            (0, common_1.assertParamExists)('createPointOfContactFacilitiesFacilityIdPointOfContactsPost', 'createFacilityPointOfContact', createFacilityPointOfContact);
                            localVarPath = "/facilities/{facility_id}/point-of-contacts"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFacilityPointOfContact, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a dock at a specified facility.
         * @summary Delete Dock
         * @param {string} dockId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDockFacilitiesFacilityIdDocksDockIdDelete: function (dockId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dockId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDockFacilitiesFacilityIdDocksDockIdDelete', 'dockId', dockId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDockFacilitiesFacilityIdDocksDockIdDelete', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/docks/{dock_id}"
                                .replace("{".concat("dock_id", "}"), encodeURIComponent(String(dockId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a dock appointment rule at a specified facility.
         * @summary Delete Facility Dock Appointment Rule
         * @param {string} ruleId
         * @param {string} facilityId
         * @param {string} dockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdDelete: function (ruleId, facilityId, dockId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ruleId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdDelete', 'ruleId', ruleId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdDelete', 'facilityId', facilityId);
                            // verify required parameter 'dockId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdDelete', 'dockId', dockId);
                            localVarPath = "/facilities/{facility_id}/docks/{dock_id}/rules/{rule_id}"
                                .replace("{".concat("rule_id", "}"), encodeURIComponent(String(ruleId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)))
                                .replace("{".concat("dock_id", "}"), encodeURIComponent(String(dockId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a document at a specified facility.
         * @summary Delete Facility Document
         * @param {string} facilityDocumentId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdDelete: function (facilityDocumentId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityDocumentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdDelete', 'facilityDocumentId', facilityDocumentId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdDelete', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/documents/{facility_document_id}"
                                .replace("{".concat("facility_document_id", "}"), encodeURIComponent(String(facilityDocumentId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a facility by a given id.
         * @summary Delete Facility
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityFacilitiesFacilityIdDelete: function (facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityFacilitiesFacilityIdDelete', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a holiday at a specified facility.
         * @summary Delete Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete: function (holidayId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'holidayId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete', 'holidayId', holidayId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/holidays/{holiday_id}"
                                .replace("{".concat("holiday_id", "}"), encodeURIComponent(String(holidayId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a point of contact at a specified facility.
         * @summary Delete Facility Point Of Contact
         * @param {string} facilityPointOfContactId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityPointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdDelete: function (facilityPointOfContactId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityPointOfContactId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityPointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdDelete', 'facilityPointOfContactId', facilityPointOfContactId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityPointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdDelete', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/point-of-contacts/{facility_point_of_contact_id}"
                                .replace("{".concat("facility_point_of_contact_id", "}"), encodeURIComponent(String(facilityPointOfContactId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete hours of operation at a specified facility.
         * @summary Delete Hours Of Operation
         * @param {string} hoursOfOperationId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdDelete: function (hoursOfOperationId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'hoursOfOperationId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdDelete', 'hoursOfOperationId', hoursOfOperationId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdDelete', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/hours-of-operation/{hours_of_operation_id}"
                                .replace("{".concat("hours_of_operation_id", "}"), encodeURIComponent(String(hoursOfOperationId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a load type by a given id.
         * @summary Delete Load Type
         * @param {string} loadTypeId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdDelete: function (loadTypeId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdDelete', 'loadTypeId', loadTypeId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdDelete', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/load-types/{load_type_id}"
                                .replace("{".concat("load_type_id", "}"), encodeURIComponent(String(loadTypeId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of facilities, optionally filtered.
         * @summary List Facilities
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {Array<FacilityIncludeQueryOptionEnum>} [include] Include child entities that are not returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilitiesFacilitiesGet: function (page, limit, sort, include, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/facilities";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of availabilities at a specified facility.
         * @summary List Facility Availability
         * @param {string} facilityId
         * @param {AvailabilityRequest} availabilityRequest
         * @param {Array<AvailabilityIncludeParams>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityAvailabilityFacilitiesFacilityIdAvailabilityPost: function (facilityId, availabilityRequest, include, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('listFacilityAvailabilityFacilitiesFacilityIdAvailabilityPost', 'facilityId', facilityId);
                            // verify required parameter 'availabilityRequest' is not null or undefined
                            (0, common_1.assertParamExists)('listFacilityAvailabilityFacilitiesFacilityIdAvailabilityPost', 'availabilityRequest', availabilityRequest);
                            localVarPath = "/facilities/{facility_id}/availability"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(availabilityRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of dock appointment rules at a specified facility.
         * @summary List Facility Dock Appointment Rules
         * @param {string} facilityId
         * @param {string} dockId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityDockAppointmentRulesFacilitiesFacilityIdDocksDockIdRulesGet: function (facilityId, dockId, page, limit, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('listFacilityDockAppointmentRulesFacilitiesFacilityIdDocksDockIdRulesGet', 'facilityId', facilityId);
                            // verify required parameter 'dockId' is not null or undefined
                            (0, common_1.assertParamExists)('listFacilityDockAppointmentRulesFacilitiesFacilityIdDocksDockIdRulesGet', 'dockId', dockId);
                            localVarPath = "/facilities/{facility_id}/docks/{dock_id}/rules"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)))
                                .replace("{".concat("dock_id", "}"), encodeURIComponent(String(dockId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of docks at a specified facility.
         * @summary List Facility Docks
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityDocksFacilitiesFacilityIdDocksGet: function (facilityId, page, limit, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('listFacilityDocksFacilitiesFacilityIdDocksGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/docks"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of documents at a specified facility.
         * @summary List Facility Facility Documents
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityFacilityDocumentsFacilitiesFacilityIdDocumentsGet: function (facilityId, page, limit, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('listFacilityFacilityDocumentsFacilitiesFacilityIdDocumentsGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/documents"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of facility holidays at a specified facility.
         * @summary List Facility Holidays
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityHolidaysFacilitiesFacilityIdHolidaysGet: function (facilityId, page, limit, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('listFacilityHolidaysFacilitiesFacilityIdHolidaysGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/holidays"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of hours of operation at a specified facility.
         * @summary List Facility Hours Of Operation
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityHoursOfOperationFacilitiesFacilityIdHoursOfOperationGet: function (facilityId, page, limit, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('listFacilityHoursOfOperationFacilitiesFacilityIdHoursOfOperationGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/hours-of-operation"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of point of contacts at a specified facility.
         * @summary List Facility Point Of Contacts
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityPointOfContactsFacilitiesFacilityIdPointOfContactsGet: function (facilityId, page, limit, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('listFacilityPointOfContactsFacilitiesFacilityIdPointOfContactsGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/point-of-contacts"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of load types, optionally filtered.
         * @summary List Load Types
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadTypesFacilitiesFacilityIdLoadTypesGet: function (facilityId, page, limit, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('listLoadTypesFacilitiesFacilityIdLoadTypesGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/load-types"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Match characteristics of freight to LoadTypes and Docks at a given Facility.
         * @summary Match Load Type Dock Rules
         * @param {string} facilityId
         * @param {LoadTypeDockRuleMatchRequest} loadTypeDockRuleMatchRequest
         * @param {Array<ShipmentMatchingIncludeParams>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchLoadTypeDockRulesFacilitiesFacilityIdLoadTypeDockRuleMatchingPost: function (facilityId, loadTypeDockRuleMatchRequest, include, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('matchLoadTypeDockRulesFacilitiesFacilityIdLoadTypeDockRuleMatchingPost', 'facilityId', facilityId);
                            // verify required parameter 'loadTypeDockRuleMatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('matchLoadTypeDockRulesFacilitiesFacilityIdLoadTypeDockRuleMatchingPost', 'loadTypeDockRuleMatchRequest', loadTypeDockRuleMatchRequest);
                            localVarPath = "/facilities/{facility_id}/load-type-dock-rule-matching"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loadTypeDockRuleMatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Match a (shipment, stop) pair to LoadTypes and Docks at a given Facility.
         * @summary Match Shipment
         * @param {string} facilityId
         * @param {string} shipmentId
         * @param {string} stopId
         * @param {Array<ShipmentMatchingIncludeParams>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchShipmentFacilitiesFacilityIdShipmentMatchingGet: function (facilityId, shipmentId, stopId, include, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('matchShipmentFacilitiesFacilityIdShipmentMatchingGet', 'facilityId', facilityId);
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('matchShipmentFacilitiesFacilityIdShipmentMatchingGet', 'shipmentId', shipmentId);
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('matchShipmentFacilitiesFacilityIdShipmentMatchingGet', 'stopId', stopId);
                            localVarPath = "/facilities/{facility_id}/shipment-matching"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            if (stopId !== undefined) {
                                localVarQueryParameter['stop_id'] = stopId;
                            }
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a dock at a specified facility by a given id.
         * @summary Retrieve Dock
         * @param {string} dockId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDockFacilitiesFacilityIdDocksDockIdGet: function (dockId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dockId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveDockFacilitiesFacilityIdDocksDockIdGet', 'dockId', dockId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveDockFacilitiesFacilityIdDocksDockIdGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/docks/{dock_id}"
                                .replace("{".concat("dock_id", "}"), encodeURIComponent(String(dockId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a dock appointment rule at a specified facility by a given id.
         * @summary Retrieve Facility Dock Appointment Rule
         * @param {string} ruleId
         * @param {string} facilityId
         * @param {string} dockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdGet: function (ruleId, facilityId, dockId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ruleId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdGet', 'ruleId', ruleId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdGet', 'facilityId', facilityId);
                            // verify required parameter 'dockId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdGet', 'dockId', dockId);
                            localVarPath = "/facilities/{facility_id}/docks/{dock_id}/rules/{rule_id}"
                                .replace("{".concat("rule_id", "}"), encodeURIComponent(String(ruleId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)))
                                .replace("{".concat("dock_id", "}"), encodeURIComponent(String(dockId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a document from a specified facility by a given id.
         * @summary Retrieve Facility Document
         * @param {string} facilityDocumentId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdGet: function (facilityDocumentId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityDocumentId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdGet', 'facilityDocumentId', facilityDocumentId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/documents/{facility_document_id}"
                                .replace("{".concat("facility_document_id", "}"), encodeURIComponent(String(facilityDocumentId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieve a facility by a given id.
         * @summary Retrieve Facility
         * @param {string} facilityId
         * @param {Array<FacilityIncludeQueryOptionEnum>} [include] Include child entities that are not returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityFacilitiesFacilityIdGet: function (facilityId, include, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityFacilitiesFacilityIdGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a facility holiday at a specified facility by a given id.
         * @summary Retrieve Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet: function (holidayId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'holidayId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet', 'holidayId', holidayId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/holidays/{holiday_id}"
                                .replace("{".concat("holiday_id", "}"), encodeURIComponent(String(holidayId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieve a schedule of the holidays at a Facility for a given range of years
         * @summary Retrieve Facility Holiday Schedule
         * @param {string} facilityId
         * @param {number} startYear
         * @param {number} endYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet: function (facilityId, startYear, endYear, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet', 'facilityId', facilityId);
                            // verify required parameter 'startYear' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet', 'startYear', startYear);
                            // verify required parameter 'endYear' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet', 'endYear', endYear);
                            localVarPath = "/facilities/{facility_id}/holidays/schedule"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (startYear !== undefined) {
                                localVarQueryParameter['start_year'] = startYear;
                            }
                            if (endYear !== undefined) {
                                localVarQueryParameter['end_year'] = endYear;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get hours of operation from a specified facility by a given id.
         * @summary Retrieve Hours Of Operation
         * @param {string} hoursOfOperationId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdGet: function (hoursOfOperationId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'hoursOfOperationId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdGet', 'hoursOfOperationId', hoursOfOperationId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/hours-of-operation/{hours_of_operation_id}"
                                .replace("{".concat("hours_of_operation_id", "}"), encodeURIComponent(String(hoursOfOperationId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieve an individual LoadType.
         * @summary Retrieve Load Type
         * @param {string} loadTypeId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdGet: function (loadTypeId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdGet', 'loadTypeId', loadTypeId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/load-types/{load_type_id}"
                                .replace("{".concat("load_type_id", "}"), encodeURIComponent(String(loadTypeId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a point of contact from a specified facility by a given id.
         * @summary Retrieve Point Of Contact
         * @param {string} facilityPointOfContactId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdGet: function (facilityPointOfContactId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityPointOfContactId' is not null or undefined
                            (0, common_1.assertParamExists)('retrievePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdGet', 'facilityPointOfContactId', facilityPointOfContactId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('retrievePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/point-of-contacts/{facility_point_of_contact_id}"
                                .replace("{".concat("facility_point_of_contact_id", "}"), encodeURIComponent(String(facilityPointOfContactId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Standard Holiday Schedule
         * @param {number} startYear
         * @param {number} endYear
         * @param {Set<StandardHolidays>} [standardHolidayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet: function (startYear, endYear, standardHolidayName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'startYear' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet', 'startYear', startYear);
                            // verify required parameter 'endYear' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet', 'endYear', endYear);
                            localVarPath = "/facilities/standard-holidays/schedule";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (startYear !== undefined) {
                                localVarQueryParameter['start_year'] = startYear;
                            }
                            if (endYear !== undefined) {
                                localVarQueryParameter['end_year'] = endYear;
                            }
                            if (standardHolidayName) {
                                localVarQueryParameter['standard_holiday_name'] = Array.from(standardHolidayName);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a dock at a specified facility.
         * @summary Update Dock
         * @param {string} dockId
         * @param {string} facilityId
         * @param {UpdateFacilityDock} updateFacilityDock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDockFacilitiesFacilityIdDocksDockIdPut: function (dockId, facilityId, updateFacilityDock, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dockId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDockFacilitiesFacilityIdDocksDockIdPut', 'dockId', dockId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDockFacilitiesFacilityIdDocksDockIdPut', 'facilityId', facilityId);
                            // verify required parameter 'updateFacilityDock' is not null or undefined
                            (0, common_1.assertParamExists)('updateDockFacilitiesFacilityIdDocksDockIdPut', 'updateFacilityDock', updateFacilityDock);
                            localVarPath = "/facilities/{facility_id}/docks/{dock_id}"
                                .replace("{".concat("dock_id", "}"), encodeURIComponent(String(dockId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFacilityDock, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a dock appointment rule at a specified facility.
         * @summary Update Facility Dock Appointment Rule
         * @param {string} ruleId
         * @param {string} facilityId
         * @param {string} dockId
         * @param {UpdateFacilityDockAppointmentRule} updateFacilityDockAppointmentRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdPut: function (ruleId, facilityId, dockId, updateFacilityDockAppointmentRule, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ruleId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdPut', 'ruleId', ruleId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdPut', 'facilityId', facilityId);
                            // verify required parameter 'dockId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdPut', 'dockId', dockId);
                            // verify required parameter 'updateFacilityDockAppointmentRule' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdPut', 'updateFacilityDockAppointmentRule', updateFacilityDockAppointmentRule);
                            localVarPath = "/facilities/{facility_id}/docks/{dock_id}/rules/{rule_id}"
                                .replace("{".concat("rule_id", "}"), encodeURIComponent(String(ruleId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)))
                                .replace("{".concat("dock_id", "}"), encodeURIComponent(String(dockId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFacilityDockAppointmentRule, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a facility by a given id.
         * @summary Update Facility
         * @param {string} facilityId
         * @param {UpdateFacility} updateFacility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityFacilitiesFacilityIdPut: function (facilityId, updateFacility, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityFacilitiesFacilityIdPut', 'facilityId', facilityId);
                            // verify required parameter 'updateFacility' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityFacilitiesFacilityIdPut', 'updateFacility', updateFacility);
                            localVarPath = "/facilities/{facility_id}"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFacility, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a facility holiday by a given id.
         * @summary Update Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {UpdateFacilityHoliday} updateFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut: function (holidayId, facilityId, updateFacilityHoliday, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'holidayId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut', 'holidayId', holidayId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut', 'facilityId', facilityId);
                            // verify required parameter 'updateFacilityHoliday' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut', 'updateFacilityHoliday', updateFacilityHoliday);
                            localVarPath = "/facilities/{facility_id}/holidays/{holiday_id}"
                                .replace("{".concat("holiday_id", "}"), encodeURIComponent(String(holidayId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFacilityHoliday, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update hours of operation at a specified facility.
         * @summary Update Hours Of Operation
         * @param {string} hoursOfOperationId
         * @param {string} facilityId
         * @param {UpdateFacilityHoursOfOperation} updateFacilityHoursOfOperation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdPut: function (hoursOfOperationId, facilityId, updateFacilityHoursOfOperation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'hoursOfOperationId' is not null or undefined
                            (0, common_1.assertParamExists)('updateHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdPut', 'hoursOfOperationId', hoursOfOperationId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('updateHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdPut', 'facilityId', facilityId);
                            // verify required parameter 'updateFacilityHoursOfOperation' is not null or undefined
                            (0, common_1.assertParamExists)('updateHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdPut', 'updateFacilityHoursOfOperation', updateFacilityHoursOfOperation);
                            localVarPath = "/facilities/{facility_id}/hours-of-operation/{hours_of_operation_id}"
                                .replace("{".concat("hours_of_operation_id", "}"), encodeURIComponent(String(hoursOfOperationId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFacilityHoursOfOperation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a load type by a given id.
         * @summary Update Load Type
         * @param {string} loadTypeId
         * @param {string} facilityId
         * @param {UpdateLoadType} updateLoadType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdPut: function (loadTypeId, facilityId, updateLoadType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('updateLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdPut', 'loadTypeId', loadTypeId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('updateLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdPut', 'facilityId', facilityId);
                            // verify required parameter 'updateLoadType' is not null or undefined
                            (0, common_1.assertParamExists)('updateLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdPut', 'updateLoadType', updateLoadType);
                            localVarPath = "/facilities/{facility_id}/load-types/{load_type_id}"
                                .replace("{".concat("load_type_id", "}"), encodeURIComponent(String(loadTypeId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateLoadType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a point of contact at a specified facility.
         * @summary Update Point Of Contact
         * @param {string} facilityPointOfContactId
         * @param {string} facilityId
         * @param {UpdateFacilityPointOfContact} updateFacilityPointOfContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdPut: function (facilityPointOfContactId, facilityId, updateFacilityPointOfContact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityPointOfContactId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdPut', 'facilityPointOfContactId', facilityPointOfContactId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdPut', 'facilityId', facilityId);
                            // verify required parameter 'updateFacilityPointOfContact' is not null or undefined
                            (0, common_1.assertParamExists)('updatePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdPut', 'updateFacilityPointOfContact', updateFacilityPointOfContact);
                            localVarPath = "/facilities/{facility_id}/point-of-contacts/{facility_point_of_contact_id}"
                                .replace("{".concat("facility_point_of_contact_id", "}"), encodeURIComponent(String(facilityPointOfContactId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFacilityPointOfContact, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FacilitiesApiAxiosParamCreator = FacilitiesApiAxiosParamCreator;
/**
 * FacilitiesApi - functional programming interface
 * @export
 */
var FacilitiesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FacilitiesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Update all FacilityHoursOfOperation on a given Facility in one request. This will delete all existing FacilityHoursOfOperation on the Facility, then recreate them according to the data in the request.
         * @summary Bulk Update Hours Of Operation
         * @param {string} facilityId
         * @param {BulkUpdateHoursOfOperationRequest} bulkUpdateHoursOfOperationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateHoursOfOperationFacilitiesFacilityIdHoursOfOperationPatch: function (facilityId, bulkUpdateHoursOfOperationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkUpdateHoursOfOperationFacilitiesFacilityIdHoursOfOperationPatch(facilityId, bulkUpdateHoursOfOperationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a dock at a specified facility.
         * @summary Create Dock
         * @param {string} facilityId
         * @param {CreateFacilityDock} createFacilityDock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDockFacilitiesFacilityIdDocksPost: function (facilityId, createFacilityDock, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDockFacilitiesFacilityIdDocksPost(facilityId, createFacilityDock, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a dock appointment rule at a specified facility.
         * @summary Create Facility Dock Appointment Rule
         * @param {string} facilityId
         * @param {string} dockId
         * @param {CreateFacilityDockAppointmentRule} createFacilityDockAppointmentRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesPost: function (facilityId, dockId, createFacilityDockAppointmentRule, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesPost(facilityId, dockId, createFacilityDockAppointmentRule, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Upload a document at a specified facility.
         * @summary Create Facility Document
         * @param {string} facilityId
         * @param {File} file
         * @param {string} [documentType]
         * @param {string} [description]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityDocumentFacilitiesFacilityIdDocumentsPost: function (facilityId, file, documentType, description, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFacilityDocumentFacilitiesFacilityIdDocumentsPost(facilityId, file, documentType, description, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a facility.
         * @summary Create Facility
         * @param {CreateFacility} createFacility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityFacilitiesPost: function (createFacility, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFacilityFacilitiesPost(createFacility, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a holiday at a facility.
         * @summary Create Facility Holiday
         * @param {string} facilityId
         * @param {CreateFacilityHoliday} createFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityHolidayFacilitiesFacilityIdHolidaysPost: function (facilityId, createFacilityHoliday, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFacilityHolidayFacilitiesFacilityIdHolidaysPost(facilityId, createFacilityHoliday, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a load type.
         * @summary Create Facility Load Type
         * @param {string} facilityId
         * @param {CreateLoadType} createLoadType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityLoadTypeFacilitiesFacilityIdLoadTypesPost: function (facilityId, createLoadType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFacilityLoadTypeFacilitiesFacilityIdLoadTypesPost(facilityId, createLoadType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create hours of operation at a specified facility.
         * @summary Create Hours Of Operation
         * @param {string} facilityId
         * @param {CreateFacilityHoursOfOperation} createFacilityHoursOfOperation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHoursOfOperationFacilitiesFacilityIdHoursOfOperationPost: function (facilityId, createFacilityHoursOfOperation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createHoursOfOperationFacilitiesFacilityIdHoursOfOperationPost(facilityId, createFacilityHoursOfOperation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a point of contact at a specified facility.
         * @summary Create Point Of Contact
         * @param {string} facilityId
         * @param {CreateFacilityPointOfContact} createFacilityPointOfContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPointOfContactFacilitiesFacilityIdPointOfContactsPost: function (facilityId, createFacilityPointOfContact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPointOfContactFacilitiesFacilityIdPointOfContactsPost(facilityId, createFacilityPointOfContact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a dock at a specified facility.
         * @summary Delete Dock
         * @param {string} dockId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDockFacilitiesFacilityIdDocksDockIdDelete: function (dockId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDockFacilitiesFacilityIdDocksDockIdDelete(dockId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a dock appointment rule at a specified facility.
         * @summary Delete Facility Dock Appointment Rule
         * @param {string} ruleId
         * @param {string} facilityId
         * @param {string} dockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdDelete: function (ruleId, facilityId, dockId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdDelete(ruleId, facilityId, dockId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a document at a specified facility.
         * @summary Delete Facility Document
         * @param {string} facilityDocumentId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdDelete: function (facilityDocumentId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdDelete(facilityDocumentId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a facility by a given id.
         * @summary Delete Facility
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityFacilitiesFacilityIdDelete: function (facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFacilityFacilitiesFacilityIdDelete(facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a holiday at a specified facility.
         * @summary Delete Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete: function (holidayId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete(holidayId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a point of contact at a specified facility.
         * @summary Delete Facility Point Of Contact
         * @param {string} facilityPointOfContactId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityPointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdDelete: function (facilityPointOfContactId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFacilityPointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdDelete(facilityPointOfContactId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete hours of operation at a specified facility.
         * @summary Delete Hours Of Operation
         * @param {string} hoursOfOperationId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdDelete: function (hoursOfOperationId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdDelete(hoursOfOperationId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a load type by a given id.
         * @summary Delete Load Type
         * @param {string} loadTypeId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdDelete: function (loadTypeId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdDelete(loadTypeId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a list of facilities, optionally filtered.
         * @summary List Facilities
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {Array<FacilityIncludeQueryOptionEnum>} [include] Include child entities that are not returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilitiesFacilitiesGet: function (page, limit, sort, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFacilitiesFacilitiesGet(page, limit, sort, include, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a list of availabilities at a specified facility.
         * @summary List Facility Availability
         * @param {string} facilityId
         * @param {AvailabilityRequest} availabilityRequest
         * @param {Array<AvailabilityIncludeParams>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityAvailabilityFacilitiesFacilityIdAvailabilityPost: function (facilityId, availabilityRequest, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFacilityAvailabilityFacilitiesFacilityIdAvailabilityPost(facilityId, availabilityRequest, include, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a list of dock appointment rules at a specified facility.
         * @summary List Facility Dock Appointment Rules
         * @param {string} facilityId
         * @param {string} dockId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityDockAppointmentRulesFacilitiesFacilityIdDocksDockIdRulesGet: function (facilityId, dockId, page, limit, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFacilityDockAppointmentRulesFacilitiesFacilityIdDocksDockIdRulesGet(facilityId, dockId, page, limit, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a list of docks at a specified facility.
         * @summary List Facility Docks
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityDocksFacilitiesFacilityIdDocksGet: function (facilityId, page, limit, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFacilityDocksFacilitiesFacilityIdDocksGet(facilityId, page, limit, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a list of documents at a specified facility.
         * @summary List Facility Facility Documents
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityFacilityDocumentsFacilitiesFacilityIdDocumentsGet: function (facilityId, page, limit, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFacilityFacilityDocumentsFacilitiesFacilityIdDocumentsGet(facilityId, page, limit, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a list of facility holidays at a specified facility.
         * @summary List Facility Holidays
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityHolidaysFacilitiesFacilityIdHolidaysGet: function (facilityId, page, limit, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFacilityHolidaysFacilitiesFacilityIdHolidaysGet(facilityId, page, limit, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a list of hours of operation at a specified facility.
         * @summary List Facility Hours Of Operation
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityHoursOfOperationFacilitiesFacilityIdHoursOfOperationGet: function (facilityId, page, limit, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFacilityHoursOfOperationFacilitiesFacilityIdHoursOfOperationGet(facilityId, page, limit, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a list of point of contacts at a specified facility.
         * @summary List Facility Point Of Contacts
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityPointOfContactsFacilitiesFacilityIdPointOfContactsGet: function (facilityId, page, limit, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFacilityPointOfContactsFacilitiesFacilityIdPointOfContactsGet(facilityId, page, limit, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a list of load types, optionally filtered.
         * @summary List Load Types
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadTypesFacilitiesFacilityIdLoadTypesGet: function (facilityId, page, limit, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listLoadTypesFacilitiesFacilityIdLoadTypesGet(facilityId, page, limit, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Match characteristics of freight to LoadTypes and Docks at a given Facility.
         * @summary Match Load Type Dock Rules
         * @param {string} facilityId
         * @param {LoadTypeDockRuleMatchRequest} loadTypeDockRuleMatchRequest
         * @param {Array<ShipmentMatchingIncludeParams>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchLoadTypeDockRulesFacilitiesFacilityIdLoadTypeDockRuleMatchingPost: function (facilityId, loadTypeDockRuleMatchRequest, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.matchLoadTypeDockRulesFacilitiesFacilityIdLoadTypeDockRuleMatchingPost(facilityId, loadTypeDockRuleMatchRequest, include, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Match a (shipment, stop) pair to LoadTypes and Docks at a given Facility.
         * @summary Match Shipment
         * @param {string} facilityId
         * @param {string} shipmentId
         * @param {string} stopId
         * @param {Array<ShipmentMatchingIncludeParams>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchShipmentFacilitiesFacilityIdShipmentMatchingGet: function (facilityId, shipmentId, stopId, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.matchShipmentFacilitiesFacilityIdShipmentMatchingGet(facilityId, shipmentId, stopId, include, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a dock at a specified facility by a given id.
         * @summary Retrieve Dock
         * @param {string} dockId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDockFacilitiesFacilityIdDocksDockIdGet: function (dockId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveDockFacilitiesFacilityIdDocksDockIdGet(dockId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a dock appointment rule at a specified facility by a given id.
         * @summary Retrieve Facility Dock Appointment Rule
         * @param {string} ruleId
         * @param {string} facilityId
         * @param {string} dockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdGet: function (ruleId, facilityId, dockId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdGet(ruleId, facilityId, dockId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a document from a specified facility by a given id.
         * @summary Retrieve Facility Document
         * @param {string} facilityDocumentId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdGet: function (facilityDocumentId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdGet(facilityDocumentId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve a facility by a given id.
         * @summary Retrieve Facility
         * @param {string} facilityId
         * @param {Array<FacilityIncludeQueryOptionEnum>} [include] Include child entities that are not returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityFacilitiesFacilityIdGet: function (facilityId, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveFacilityFacilitiesFacilityIdGet(facilityId, include, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a facility holiday at a specified facility by a given id.
         * @summary Retrieve Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet: function (holidayId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet(holidayId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve a schedule of the holidays at a Facility for a given range of years
         * @summary Retrieve Facility Holiday Schedule
         * @param {string} facilityId
         * @param {number} startYear
         * @param {number} endYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet: function (facilityId, startYear, endYear, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet(facilityId, startYear, endYear, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get hours of operation from a specified facility by a given id.
         * @summary Retrieve Hours Of Operation
         * @param {string} hoursOfOperationId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdGet: function (hoursOfOperationId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdGet(hoursOfOperationId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve an individual LoadType.
         * @summary Retrieve Load Type
         * @param {string} loadTypeId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdGet: function (loadTypeId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdGet(loadTypeId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a point of contact from a specified facility by a given id.
         * @summary Retrieve Point Of Contact
         * @param {string} facilityPointOfContactId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdGet: function (facilityPointOfContactId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrievePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdGet(facilityPointOfContactId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Standard Holiday Schedule
         * @param {number} startYear
         * @param {number} endYear
         * @param {Set<StandardHolidays>} [standardHolidayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet: function (startYear, endYear, standardHolidayName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet(startYear, endYear, standardHolidayName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update a dock at a specified facility.
         * @summary Update Dock
         * @param {string} dockId
         * @param {string} facilityId
         * @param {UpdateFacilityDock} updateFacilityDock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDockFacilitiesFacilityIdDocksDockIdPut: function (dockId, facilityId, updateFacilityDock, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDockFacilitiesFacilityIdDocksDockIdPut(dockId, facilityId, updateFacilityDock, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update a dock appointment rule at a specified facility.
         * @summary Update Facility Dock Appointment Rule
         * @param {string} ruleId
         * @param {string} facilityId
         * @param {string} dockId
         * @param {UpdateFacilityDockAppointmentRule} updateFacilityDockAppointmentRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdPut: function (ruleId, facilityId, dockId, updateFacilityDockAppointmentRule, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdPut(ruleId, facilityId, dockId, updateFacilityDockAppointmentRule, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update a facility by a given id.
         * @summary Update Facility
         * @param {string} facilityId
         * @param {UpdateFacility} updateFacility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityFacilitiesFacilityIdPut: function (facilityId, updateFacility, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFacilityFacilitiesFacilityIdPut(facilityId, updateFacility, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update a facility holiday by a given id.
         * @summary Update Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {UpdateFacilityHoliday} updateFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut: function (holidayId, facilityId, updateFacilityHoliday, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut(holidayId, facilityId, updateFacilityHoliday, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update hours of operation at a specified facility.
         * @summary Update Hours Of Operation
         * @param {string} hoursOfOperationId
         * @param {string} facilityId
         * @param {UpdateFacilityHoursOfOperation} updateFacilityHoursOfOperation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdPut: function (hoursOfOperationId, facilityId, updateFacilityHoursOfOperation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdPut(hoursOfOperationId, facilityId, updateFacilityHoursOfOperation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update a load type by a given id.
         * @summary Update Load Type
         * @param {string} loadTypeId
         * @param {string} facilityId
         * @param {UpdateLoadType} updateLoadType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdPut: function (loadTypeId, facilityId, updateLoadType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdPut(loadTypeId, facilityId, updateLoadType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update a point of contact at a specified facility.
         * @summary Update Point Of Contact
         * @param {string} facilityPointOfContactId
         * @param {string} facilityId
         * @param {UpdateFacilityPointOfContact} updateFacilityPointOfContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdPut: function (facilityPointOfContactId, facilityId, updateFacilityPointOfContact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdPut(facilityPointOfContactId, facilityId, updateFacilityPointOfContact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FacilitiesApiFp = FacilitiesApiFp;
/**
 * FacilitiesApi - factory interface
 * @export
 */
var FacilitiesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FacilitiesApiFp)(configuration);
    return {
        /**
         * Update all FacilityHoursOfOperation on a given Facility in one request. This will delete all existing FacilityHoursOfOperation on the Facility, then recreate them according to the data in the request.
         * @summary Bulk Update Hours Of Operation
         * @param {string} facilityId
         * @param {BulkUpdateHoursOfOperationRequest} bulkUpdateHoursOfOperationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateHoursOfOperationFacilitiesFacilityIdHoursOfOperationPatch: function (facilityId, bulkUpdateHoursOfOperationRequest, options) {
            return localVarFp.bulkUpdateHoursOfOperationFacilitiesFacilityIdHoursOfOperationPatch(facilityId, bulkUpdateHoursOfOperationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a dock at a specified facility.
         * @summary Create Dock
         * @param {string} facilityId
         * @param {CreateFacilityDock} createFacilityDock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDockFacilitiesFacilityIdDocksPost: function (facilityId, createFacilityDock, options) {
            return localVarFp.createDockFacilitiesFacilityIdDocksPost(facilityId, createFacilityDock, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a dock appointment rule at a specified facility.
         * @summary Create Facility Dock Appointment Rule
         * @param {string} facilityId
         * @param {string} dockId
         * @param {CreateFacilityDockAppointmentRule} createFacilityDockAppointmentRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesPost: function (facilityId, dockId, createFacilityDockAppointmentRule, options) {
            return localVarFp.createFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesPost(facilityId, dockId, createFacilityDockAppointmentRule, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Upload a document at a specified facility.
         * @summary Create Facility Document
         * @param {string} facilityId
         * @param {File} file
         * @param {string} [documentType]
         * @param {string} [description]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityDocumentFacilitiesFacilityIdDocumentsPost: function (facilityId, file, documentType, description, options) {
            return localVarFp.createFacilityDocumentFacilitiesFacilityIdDocumentsPost(facilityId, file, documentType, description, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a facility.
         * @summary Create Facility
         * @param {CreateFacility} createFacility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityFacilitiesPost: function (createFacility, options) {
            return localVarFp.createFacilityFacilitiesPost(createFacility, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a holiday at a facility.
         * @summary Create Facility Holiday
         * @param {string} facilityId
         * @param {CreateFacilityHoliday} createFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityHolidayFacilitiesFacilityIdHolidaysPost: function (facilityId, createFacilityHoliday, options) {
            return localVarFp.createFacilityHolidayFacilitiesFacilityIdHolidaysPost(facilityId, createFacilityHoliday, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a load type.
         * @summary Create Facility Load Type
         * @param {string} facilityId
         * @param {CreateLoadType} createLoadType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityLoadTypeFacilitiesFacilityIdLoadTypesPost: function (facilityId, createLoadType, options) {
            return localVarFp.createFacilityLoadTypeFacilitiesFacilityIdLoadTypesPost(facilityId, createLoadType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create hours of operation at a specified facility.
         * @summary Create Hours Of Operation
         * @param {string} facilityId
         * @param {CreateFacilityHoursOfOperation} createFacilityHoursOfOperation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHoursOfOperationFacilitiesFacilityIdHoursOfOperationPost: function (facilityId, createFacilityHoursOfOperation, options) {
            return localVarFp.createHoursOfOperationFacilitiesFacilityIdHoursOfOperationPost(facilityId, createFacilityHoursOfOperation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a point of contact at a specified facility.
         * @summary Create Point Of Contact
         * @param {string} facilityId
         * @param {CreateFacilityPointOfContact} createFacilityPointOfContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPointOfContactFacilitiesFacilityIdPointOfContactsPost: function (facilityId, createFacilityPointOfContact, options) {
            return localVarFp.createPointOfContactFacilitiesFacilityIdPointOfContactsPost(facilityId, createFacilityPointOfContact, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a dock at a specified facility.
         * @summary Delete Dock
         * @param {string} dockId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDockFacilitiesFacilityIdDocksDockIdDelete: function (dockId, facilityId, options) {
            return localVarFp.deleteDockFacilitiesFacilityIdDocksDockIdDelete(dockId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a dock appointment rule at a specified facility.
         * @summary Delete Facility Dock Appointment Rule
         * @param {string} ruleId
         * @param {string} facilityId
         * @param {string} dockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdDelete: function (ruleId, facilityId, dockId, options) {
            return localVarFp.deleteFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdDelete(ruleId, facilityId, dockId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a document at a specified facility.
         * @summary Delete Facility Document
         * @param {string} facilityDocumentId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdDelete: function (facilityDocumentId, facilityId, options) {
            return localVarFp.deleteFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdDelete(facilityDocumentId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a facility by a given id.
         * @summary Delete Facility
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityFacilitiesFacilityIdDelete: function (facilityId, options) {
            return localVarFp.deleteFacilityFacilitiesFacilityIdDelete(facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a holiday at a specified facility.
         * @summary Delete Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete: function (holidayId, facilityId, options) {
            return localVarFp.deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete(holidayId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a point of contact at a specified facility.
         * @summary Delete Facility Point Of Contact
         * @param {string} facilityPointOfContactId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityPointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdDelete: function (facilityPointOfContactId, facilityId, options) {
            return localVarFp.deleteFacilityPointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdDelete(facilityPointOfContactId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete hours of operation at a specified facility.
         * @summary Delete Hours Of Operation
         * @param {string} hoursOfOperationId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdDelete: function (hoursOfOperationId, facilityId, options) {
            return localVarFp.deleteHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdDelete(hoursOfOperationId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a load type by a given id.
         * @summary Delete Load Type
         * @param {string} loadTypeId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdDelete: function (loadTypeId, facilityId, options) {
            return localVarFp.deleteLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdDelete(loadTypeId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of facilities, optionally filtered.
         * @summary List Facilities
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {Array<FacilityIncludeQueryOptionEnum>} [include] Include child entities that are not returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilitiesFacilitiesGet: function (page, limit, sort, include, options) {
            return localVarFp.listFacilitiesFacilitiesGet(page, limit, sort, include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of availabilities at a specified facility.
         * @summary List Facility Availability
         * @param {string} facilityId
         * @param {AvailabilityRequest} availabilityRequest
         * @param {Array<AvailabilityIncludeParams>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityAvailabilityFacilitiesFacilityIdAvailabilityPost: function (facilityId, availabilityRequest, include, options) {
            return localVarFp.listFacilityAvailabilityFacilitiesFacilityIdAvailabilityPost(facilityId, availabilityRequest, include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of dock appointment rules at a specified facility.
         * @summary List Facility Dock Appointment Rules
         * @param {string} facilityId
         * @param {string} dockId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityDockAppointmentRulesFacilitiesFacilityIdDocksDockIdRulesGet: function (facilityId, dockId, page, limit, sort, options) {
            return localVarFp.listFacilityDockAppointmentRulesFacilitiesFacilityIdDocksDockIdRulesGet(facilityId, dockId, page, limit, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of docks at a specified facility.
         * @summary List Facility Docks
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityDocksFacilitiesFacilityIdDocksGet: function (facilityId, page, limit, sort, options) {
            return localVarFp.listFacilityDocksFacilitiesFacilityIdDocksGet(facilityId, page, limit, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of documents at a specified facility.
         * @summary List Facility Facility Documents
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityFacilityDocumentsFacilitiesFacilityIdDocumentsGet: function (facilityId, page, limit, sort, options) {
            return localVarFp.listFacilityFacilityDocumentsFacilitiesFacilityIdDocumentsGet(facilityId, page, limit, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of facility holidays at a specified facility.
         * @summary List Facility Holidays
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityHolidaysFacilitiesFacilityIdHolidaysGet: function (facilityId, page, limit, sort, options) {
            return localVarFp.listFacilityHolidaysFacilitiesFacilityIdHolidaysGet(facilityId, page, limit, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of hours of operation at a specified facility.
         * @summary List Facility Hours Of Operation
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityHoursOfOperationFacilitiesFacilityIdHoursOfOperationGet: function (facilityId, page, limit, sort, options) {
            return localVarFp.listFacilityHoursOfOperationFacilitiesFacilityIdHoursOfOperationGet(facilityId, page, limit, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of point of contacts at a specified facility.
         * @summary List Facility Point Of Contacts
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityPointOfContactsFacilitiesFacilityIdPointOfContactsGet: function (facilityId, page, limit, sort, options) {
            return localVarFp.listFacilityPointOfContactsFacilitiesFacilityIdPointOfContactsGet(facilityId, page, limit, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of load types, optionally filtered.
         * @summary List Load Types
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadTypesFacilitiesFacilityIdLoadTypesGet: function (facilityId, page, limit, sort, options) {
            return localVarFp.listLoadTypesFacilitiesFacilityIdLoadTypesGet(facilityId, page, limit, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Match characteristics of freight to LoadTypes and Docks at a given Facility.
         * @summary Match Load Type Dock Rules
         * @param {string} facilityId
         * @param {LoadTypeDockRuleMatchRequest} loadTypeDockRuleMatchRequest
         * @param {Array<ShipmentMatchingIncludeParams>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchLoadTypeDockRulesFacilitiesFacilityIdLoadTypeDockRuleMatchingPost: function (facilityId, loadTypeDockRuleMatchRequest, include, options) {
            return localVarFp.matchLoadTypeDockRulesFacilitiesFacilityIdLoadTypeDockRuleMatchingPost(facilityId, loadTypeDockRuleMatchRequest, include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Match a (shipment, stop) pair to LoadTypes and Docks at a given Facility.
         * @summary Match Shipment
         * @param {string} facilityId
         * @param {string} shipmentId
         * @param {string} stopId
         * @param {Array<ShipmentMatchingIncludeParams>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchShipmentFacilitiesFacilityIdShipmentMatchingGet: function (facilityId, shipmentId, stopId, include, options) {
            return localVarFp.matchShipmentFacilitiesFacilityIdShipmentMatchingGet(facilityId, shipmentId, stopId, include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a dock at a specified facility by a given id.
         * @summary Retrieve Dock
         * @param {string} dockId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDockFacilitiesFacilityIdDocksDockIdGet: function (dockId, facilityId, options) {
            return localVarFp.retrieveDockFacilitiesFacilityIdDocksDockIdGet(dockId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a dock appointment rule at a specified facility by a given id.
         * @summary Retrieve Facility Dock Appointment Rule
         * @param {string} ruleId
         * @param {string} facilityId
         * @param {string} dockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdGet: function (ruleId, facilityId, dockId, options) {
            return localVarFp.retrieveFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdGet(ruleId, facilityId, dockId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a document from a specified facility by a given id.
         * @summary Retrieve Facility Document
         * @param {string} facilityDocumentId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdGet: function (facilityDocumentId, facilityId, options) {
            return localVarFp.retrieveFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdGet(facilityDocumentId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve a facility by a given id.
         * @summary Retrieve Facility
         * @param {string} facilityId
         * @param {Array<FacilityIncludeQueryOptionEnum>} [include] Include child entities that are not returned by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityFacilitiesFacilityIdGet: function (facilityId, include, options) {
            return localVarFp.retrieveFacilityFacilitiesFacilityIdGet(facilityId, include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a facility holiday at a specified facility by a given id.
         * @summary Retrieve Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet: function (holidayId, facilityId, options) {
            return localVarFp.retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet(holidayId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve a schedule of the holidays at a Facility for a given range of years
         * @summary Retrieve Facility Holiday Schedule
         * @param {string} facilityId
         * @param {number} startYear
         * @param {number} endYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet: function (facilityId, startYear, endYear, options) {
            return localVarFp.retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet(facilityId, startYear, endYear, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get hours of operation from a specified facility by a given id.
         * @summary Retrieve Hours Of Operation
         * @param {string} hoursOfOperationId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdGet: function (hoursOfOperationId, facilityId, options) {
            return localVarFp.retrieveHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdGet(hoursOfOperationId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve an individual LoadType.
         * @summary Retrieve Load Type
         * @param {string} loadTypeId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdGet: function (loadTypeId, facilityId, options) {
            return localVarFp.retrieveLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdGet(loadTypeId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a point of contact from a specified facility by a given id.
         * @summary Retrieve Point Of Contact
         * @param {string} facilityPointOfContactId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdGet: function (facilityPointOfContactId, facilityId, options) {
            return localVarFp.retrievePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdGet(facilityPointOfContactId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve Standard Holiday Schedule
         * @param {number} startYear
         * @param {number} endYear
         * @param {Set<StandardHolidays>} [standardHolidayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet: function (startYear, endYear, standardHolidayName, options) {
            return localVarFp.retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet(startYear, endYear, standardHolidayName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a dock at a specified facility.
         * @summary Update Dock
         * @param {string} dockId
         * @param {string} facilityId
         * @param {UpdateFacilityDock} updateFacilityDock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDockFacilitiesFacilityIdDocksDockIdPut: function (dockId, facilityId, updateFacilityDock, options) {
            return localVarFp.updateDockFacilitiesFacilityIdDocksDockIdPut(dockId, facilityId, updateFacilityDock, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a dock appointment rule at a specified facility.
         * @summary Update Facility Dock Appointment Rule
         * @param {string} ruleId
         * @param {string} facilityId
         * @param {string} dockId
         * @param {UpdateFacilityDockAppointmentRule} updateFacilityDockAppointmentRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdPut: function (ruleId, facilityId, dockId, updateFacilityDockAppointmentRule, options) {
            return localVarFp.updateFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdPut(ruleId, facilityId, dockId, updateFacilityDockAppointmentRule, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a facility by a given id.
         * @summary Update Facility
         * @param {string} facilityId
         * @param {UpdateFacility} updateFacility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityFacilitiesFacilityIdPut: function (facilityId, updateFacility, options) {
            return localVarFp.updateFacilityFacilitiesFacilityIdPut(facilityId, updateFacility, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a facility holiday by a given id.
         * @summary Update Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {UpdateFacilityHoliday} updateFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut: function (holidayId, facilityId, updateFacilityHoliday, options) {
            return localVarFp.updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut(holidayId, facilityId, updateFacilityHoliday, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update hours of operation at a specified facility.
         * @summary Update Hours Of Operation
         * @param {string} hoursOfOperationId
         * @param {string} facilityId
         * @param {UpdateFacilityHoursOfOperation} updateFacilityHoursOfOperation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdPut: function (hoursOfOperationId, facilityId, updateFacilityHoursOfOperation, options) {
            return localVarFp.updateHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdPut(hoursOfOperationId, facilityId, updateFacilityHoursOfOperation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a load type by a given id.
         * @summary Update Load Type
         * @param {string} loadTypeId
         * @param {string} facilityId
         * @param {UpdateLoadType} updateLoadType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdPut: function (loadTypeId, facilityId, updateLoadType, options) {
            return localVarFp.updateLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdPut(loadTypeId, facilityId, updateLoadType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a point of contact at a specified facility.
         * @summary Update Point Of Contact
         * @param {string} facilityPointOfContactId
         * @param {string} facilityId
         * @param {UpdateFacilityPointOfContact} updateFacilityPointOfContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdPut: function (facilityPointOfContactId, facilityId, updateFacilityPointOfContact, options) {
            return localVarFp.updatePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdPut(facilityPointOfContactId, facilityId, updateFacilityPointOfContact, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FacilitiesApiFactory = FacilitiesApiFactory;
/**
 * FacilitiesApi - object-oriented interface
 * @export
 * @class FacilitiesApi
 * @extends {BaseAPI}
 */
var FacilitiesApi = /** @class */ (function (_super) {
    __extends(FacilitiesApi, _super);
    function FacilitiesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update all FacilityHoursOfOperation on a given Facility in one request. This will delete all existing FacilityHoursOfOperation on the Facility, then recreate them according to the data in the request.
     * @summary Bulk Update Hours Of Operation
     * @param {string} facilityId
     * @param {BulkUpdateHoursOfOperationRequest} bulkUpdateHoursOfOperationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.bulkUpdateHoursOfOperationFacilitiesFacilityIdHoursOfOperationPatch = function (facilityId, bulkUpdateHoursOfOperationRequest, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).bulkUpdateHoursOfOperationFacilitiesFacilityIdHoursOfOperationPatch(facilityId, bulkUpdateHoursOfOperationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a dock at a specified facility.
     * @summary Create Dock
     * @param {string} facilityId
     * @param {CreateFacilityDock} createFacilityDock
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.createDockFacilitiesFacilityIdDocksPost = function (facilityId, createFacilityDock, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).createDockFacilitiesFacilityIdDocksPost(facilityId, createFacilityDock, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a dock appointment rule at a specified facility.
     * @summary Create Facility Dock Appointment Rule
     * @param {string} facilityId
     * @param {string} dockId
     * @param {CreateFacilityDockAppointmentRule} createFacilityDockAppointmentRule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.createFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesPost = function (facilityId, dockId, createFacilityDockAppointmentRule, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).createFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesPost(facilityId, dockId, createFacilityDockAppointmentRule, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Upload a document at a specified facility.
     * @summary Create Facility Document
     * @param {string} facilityId
     * @param {File} file
     * @param {string} [documentType]
     * @param {string} [description]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.createFacilityDocumentFacilitiesFacilityIdDocumentsPost = function (facilityId, file, documentType, description, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).createFacilityDocumentFacilitiesFacilityIdDocumentsPost(facilityId, file, documentType, description, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a facility.
     * @summary Create Facility
     * @param {CreateFacility} createFacility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.createFacilityFacilitiesPost = function (createFacility, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).createFacilityFacilitiesPost(createFacility, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a holiday at a facility.
     * @summary Create Facility Holiday
     * @param {string} facilityId
     * @param {CreateFacilityHoliday} createFacilityHoliday
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.createFacilityHolidayFacilitiesFacilityIdHolidaysPost = function (facilityId, createFacilityHoliday, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).createFacilityHolidayFacilitiesFacilityIdHolidaysPost(facilityId, createFacilityHoliday, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a load type.
     * @summary Create Facility Load Type
     * @param {string} facilityId
     * @param {CreateLoadType} createLoadType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.createFacilityLoadTypeFacilitiesFacilityIdLoadTypesPost = function (facilityId, createLoadType, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).createFacilityLoadTypeFacilitiesFacilityIdLoadTypesPost(facilityId, createLoadType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create hours of operation at a specified facility.
     * @summary Create Hours Of Operation
     * @param {string} facilityId
     * @param {CreateFacilityHoursOfOperation} createFacilityHoursOfOperation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.createHoursOfOperationFacilitiesFacilityIdHoursOfOperationPost = function (facilityId, createFacilityHoursOfOperation, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).createHoursOfOperationFacilitiesFacilityIdHoursOfOperationPost(facilityId, createFacilityHoursOfOperation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a point of contact at a specified facility.
     * @summary Create Point Of Contact
     * @param {string} facilityId
     * @param {CreateFacilityPointOfContact} createFacilityPointOfContact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.createPointOfContactFacilitiesFacilityIdPointOfContactsPost = function (facilityId, createFacilityPointOfContact, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).createPointOfContactFacilitiesFacilityIdPointOfContactsPost(facilityId, createFacilityPointOfContact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a dock at a specified facility.
     * @summary Delete Dock
     * @param {string} dockId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.deleteDockFacilitiesFacilityIdDocksDockIdDelete = function (dockId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).deleteDockFacilitiesFacilityIdDocksDockIdDelete(dockId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a dock appointment rule at a specified facility.
     * @summary Delete Facility Dock Appointment Rule
     * @param {string} ruleId
     * @param {string} facilityId
     * @param {string} dockId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.deleteFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdDelete = function (ruleId, facilityId, dockId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).deleteFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdDelete(ruleId, facilityId, dockId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a document at a specified facility.
     * @summary Delete Facility Document
     * @param {string} facilityDocumentId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.deleteFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdDelete = function (facilityDocumentId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).deleteFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdDelete(facilityDocumentId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a facility by a given id.
     * @summary Delete Facility
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.deleteFacilityFacilitiesFacilityIdDelete = function (facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).deleteFacilityFacilitiesFacilityIdDelete(facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a holiday at a specified facility.
     * @summary Delete Facility Holiday
     * @param {string} holidayId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete = function (holidayId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete(holidayId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a point of contact at a specified facility.
     * @summary Delete Facility Point Of Contact
     * @param {string} facilityPointOfContactId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.deleteFacilityPointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdDelete = function (facilityPointOfContactId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).deleteFacilityPointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdDelete(facilityPointOfContactId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete hours of operation at a specified facility.
     * @summary Delete Hours Of Operation
     * @param {string} hoursOfOperationId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.deleteHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdDelete = function (hoursOfOperationId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).deleteHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdDelete(hoursOfOperationId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a load type by a given id.
     * @summary Delete Load Type
     * @param {string} loadTypeId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.deleteLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdDelete = function (loadTypeId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).deleteLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdDelete(loadTypeId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of facilities, optionally filtered.
     * @summary List Facilities
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {Array<FacilityIncludeQueryOptionEnum>} [include] Include child entities that are not returned by default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.listFacilitiesFacilitiesGet = function (page, limit, sort, include, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).listFacilitiesFacilitiesGet(page, limit, sort, include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of availabilities at a specified facility.
     * @summary List Facility Availability
     * @param {string} facilityId
     * @param {AvailabilityRequest} availabilityRequest
     * @param {Array<AvailabilityIncludeParams>} [include]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.listFacilityAvailabilityFacilitiesFacilityIdAvailabilityPost = function (facilityId, availabilityRequest, include, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).listFacilityAvailabilityFacilitiesFacilityIdAvailabilityPost(facilityId, availabilityRequest, include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of dock appointment rules at a specified facility.
     * @summary List Facility Dock Appointment Rules
     * @param {string} facilityId
     * @param {string} dockId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.listFacilityDockAppointmentRulesFacilitiesFacilityIdDocksDockIdRulesGet = function (facilityId, dockId, page, limit, sort, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).listFacilityDockAppointmentRulesFacilitiesFacilityIdDocksDockIdRulesGet(facilityId, dockId, page, limit, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of docks at a specified facility.
     * @summary List Facility Docks
     * @param {string} facilityId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.listFacilityDocksFacilitiesFacilityIdDocksGet = function (facilityId, page, limit, sort, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).listFacilityDocksFacilitiesFacilityIdDocksGet(facilityId, page, limit, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of documents at a specified facility.
     * @summary List Facility Facility Documents
     * @param {string} facilityId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.listFacilityFacilityDocumentsFacilitiesFacilityIdDocumentsGet = function (facilityId, page, limit, sort, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).listFacilityFacilityDocumentsFacilitiesFacilityIdDocumentsGet(facilityId, page, limit, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of facility holidays at a specified facility.
     * @summary List Facility Holidays
     * @param {string} facilityId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.listFacilityHolidaysFacilitiesFacilityIdHolidaysGet = function (facilityId, page, limit, sort, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).listFacilityHolidaysFacilitiesFacilityIdHolidaysGet(facilityId, page, limit, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of hours of operation at a specified facility.
     * @summary List Facility Hours Of Operation
     * @param {string} facilityId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.listFacilityHoursOfOperationFacilitiesFacilityIdHoursOfOperationGet = function (facilityId, page, limit, sort, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).listFacilityHoursOfOperationFacilitiesFacilityIdHoursOfOperationGet(facilityId, page, limit, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of point of contacts at a specified facility.
     * @summary List Facility Point Of Contacts
     * @param {string} facilityId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.listFacilityPointOfContactsFacilitiesFacilityIdPointOfContactsGet = function (facilityId, page, limit, sort, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).listFacilityPointOfContactsFacilitiesFacilityIdPointOfContactsGet(facilityId, page, limit, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of load types, optionally filtered.
     * @summary List Load Types
     * @param {string} facilityId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.listLoadTypesFacilitiesFacilityIdLoadTypesGet = function (facilityId, page, limit, sort, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).listLoadTypesFacilitiesFacilityIdLoadTypesGet(facilityId, page, limit, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Match characteristics of freight to LoadTypes and Docks at a given Facility.
     * @summary Match Load Type Dock Rules
     * @param {string} facilityId
     * @param {LoadTypeDockRuleMatchRequest} loadTypeDockRuleMatchRequest
     * @param {Array<ShipmentMatchingIncludeParams>} [include]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.matchLoadTypeDockRulesFacilitiesFacilityIdLoadTypeDockRuleMatchingPost = function (facilityId, loadTypeDockRuleMatchRequest, include, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).matchLoadTypeDockRulesFacilitiesFacilityIdLoadTypeDockRuleMatchingPost(facilityId, loadTypeDockRuleMatchRequest, include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Match a (shipment, stop) pair to LoadTypes and Docks at a given Facility.
     * @summary Match Shipment
     * @param {string} facilityId
     * @param {string} shipmentId
     * @param {string} stopId
     * @param {Array<ShipmentMatchingIncludeParams>} [include]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.matchShipmentFacilitiesFacilityIdShipmentMatchingGet = function (facilityId, shipmentId, stopId, include, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).matchShipmentFacilitiesFacilityIdShipmentMatchingGet(facilityId, shipmentId, stopId, include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a dock at a specified facility by a given id.
     * @summary Retrieve Dock
     * @param {string} dockId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.retrieveDockFacilitiesFacilityIdDocksDockIdGet = function (dockId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).retrieveDockFacilitiesFacilityIdDocksDockIdGet(dockId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a dock appointment rule at a specified facility by a given id.
     * @summary Retrieve Facility Dock Appointment Rule
     * @param {string} ruleId
     * @param {string} facilityId
     * @param {string} dockId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.retrieveFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdGet = function (ruleId, facilityId, dockId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).retrieveFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdGet(ruleId, facilityId, dockId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a document from a specified facility by a given id.
     * @summary Retrieve Facility Document
     * @param {string} facilityDocumentId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.retrieveFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdGet = function (facilityDocumentId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).retrieveFacilityDocumentFacilitiesFacilityIdDocumentsFacilityDocumentIdGet(facilityDocumentId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve a facility by a given id.
     * @summary Retrieve Facility
     * @param {string} facilityId
     * @param {Array<FacilityIncludeQueryOptionEnum>} [include] Include child entities that are not returned by default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.retrieveFacilityFacilitiesFacilityIdGet = function (facilityId, include, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).retrieveFacilityFacilitiesFacilityIdGet(facilityId, include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a facility holiday at a specified facility by a given id.
     * @summary Retrieve Facility Holiday
     * @param {string} holidayId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet = function (holidayId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet(holidayId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve a schedule of the holidays at a Facility for a given range of years
     * @summary Retrieve Facility Holiday Schedule
     * @param {string} facilityId
     * @param {number} startYear
     * @param {number} endYear
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet = function (facilityId, startYear, endYear, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet(facilityId, startYear, endYear, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get hours of operation from a specified facility by a given id.
     * @summary Retrieve Hours Of Operation
     * @param {string} hoursOfOperationId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.retrieveHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdGet = function (hoursOfOperationId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).retrieveHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdGet(hoursOfOperationId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve an individual LoadType.
     * @summary Retrieve Load Type
     * @param {string} loadTypeId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.retrieveLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdGet = function (loadTypeId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).retrieveLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdGet(loadTypeId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a point of contact from a specified facility by a given id.
     * @summary Retrieve Point Of Contact
     * @param {string} facilityPointOfContactId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.retrievePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdGet = function (facilityPointOfContactId, facilityId, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).retrievePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdGet(facilityPointOfContactId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve Standard Holiday Schedule
     * @param {number} startYear
     * @param {number} endYear
     * @param {Set<StandardHolidays>} [standardHolidayName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet = function (startYear, endYear, standardHolidayName, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet(startYear, endYear, standardHolidayName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a dock at a specified facility.
     * @summary Update Dock
     * @param {string} dockId
     * @param {string} facilityId
     * @param {UpdateFacilityDock} updateFacilityDock
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.updateDockFacilitiesFacilityIdDocksDockIdPut = function (dockId, facilityId, updateFacilityDock, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).updateDockFacilitiesFacilityIdDocksDockIdPut(dockId, facilityId, updateFacilityDock, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a dock appointment rule at a specified facility.
     * @summary Update Facility Dock Appointment Rule
     * @param {string} ruleId
     * @param {string} facilityId
     * @param {string} dockId
     * @param {UpdateFacilityDockAppointmentRule} updateFacilityDockAppointmentRule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.updateFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdPut = function (ruleId, facilityId, dockId, updateFacilityDockAppointmentRule, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).updateFacilityDockAppointmentRuleFacilitiesFacilityIdDocksDockIdRulesRuleIdPut(ruleId, facilityId, dockId, updateFacilityDockAppointmentRule, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a facility by a given id.
     * @summary Update Facility
     * @param {string} facilityId
     * @param {UpdateFacility} updateFacility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.updateFacilityFacilitiesFacilityIdPut = function (facilityId, updateFacility, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).updateFacilityFacilitiesFacilityIdPut(facilityId, updateFacility, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a facility holiday by a given id.
     * @summary Update Facility Holiday
     * @param {string} holidayId
     * @param {string} facilityId
     * @param {UpdateFacilityHoliday} updateFacilityHoliday
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut = function (holidayId, facilityId, updateFacilityHoliday, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut(holidayId, facilityId, updateFacilityHoliday, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update hours of operation at a specified facility.
     * @summary Update Hours Of Operation
     * @param {string} hoursOfOperationId
     * @param {string} facilityId
     * @param {UpdateFacilityHoursOfOperation} updateFacilityHoursOfOperation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.updateHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdPut = function (hoursOfOperationId, facilityId, updateFacilityHoursOfOperation, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).updateHoursOfOperationFacilitiesFacilityIdHoursOfOperationHoursOfOperationIdPut(hoursOfOperationId, facilityId, updateFacilityHoursOfOperation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a load type by a given id.
     * @summary Update Load Type
     * @param {string} loadTypeId
     * @param {string} facilityId
     * @param {UpdateLoadType} updateLoadType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.updateLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdPut = function (loadTypeId, facilityId, updateLoadType, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).updateLoadTypeFacilitiesFacilityIdLoadTypesLoadTypeIdPut(loadTypeId, facilityId, updateLoadType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a point of contact at a specified facility.
     * @summary Update Point Of Contact
     * @param {string} facilityPointOfContactId
     * @param {string} facilityId
     * @param {UpdateFacilityPointOfContact} updateFacilityPointOfContact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    FacilitiesApi.prototype.updatePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdPut = function (facilityPointOfContactId, facilityId, updateFacilityPointOfContact, options) {
        var _this = this;
        return (0, exports.FacilitiesApiFp)(this.configuration).updatePointOfContactFacilitiesFacilityIdPointOfContactsFacilityPointOfContactIdPut(facilityPointOfContactId, facilityId, updateFacilityPointOfContact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FacilitiesApi;
}(base_1.BaseAPI));
exports.FacilitiesApi = FacilitiesApi;
/**
 * HolidaysApi - axios parameter creator
 * @export
 */
var HolidaysApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a holiday at a facility.
         * @summary Create Facility Holiday
         * @param {string} facilityId
         * @param {CreateFacilityHoliday} createFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityHolidayFacilitiesFacilityIdHolidaysPost: function (facilityId, createFacilityHoliday, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityHolidayFacilitiesFacilityIdHolidaysPost', 'facilityId', facilityId);
                            // verify required parameter 'createFacilityHoliday' is not null or undefined
                            (0, common_1.assertParamExists)('createFacilityHolidayFacilitiesFacilityIdHolidaysPost', 'createFacilityHoliday', createFacilityHoliday);
                            localVarPath = "/facilities/{facility_id}/holidays"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFacilityHoliday, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a holiday at a specified facility.
         * @summary Delete Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete: function (holidayId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'holidayId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete', 'holidayId', holidayId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/holidays/{holiday_id}"
                                .replace("{".concat("holiday_id", "}"), encodeURIComponent(String(holidayId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of facility holidays at a specified facility.
         * @summary List Facility Holidays
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityHolidaysFacilitiesFacilityIdHolidaysGet: function (facilityId, page, limit, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('listFacilityHolidaysFacilitiesFacilityIdHolidaysGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/holidays"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a facility holiday at a specified facility by a given id.
         * @summary Retrieve Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet: function (holidayId, facilityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'holidayId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet', 'holidayId', holidayId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet', 'facilityId', facilityId);
                            localVarPath = "/facilities/{facility_id}/holidays/{holiday_id}"
                                .replace("{".concat("holiday_id", "}"), encodeURIComponent(String(holidayId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieve a schedule of the holidays at a Facility for a given range of years
         * @summary Retrieve Facility Holiday Schedule
         * @param {string} facilityId
         * @param {number} startYear
         * @param {number} endYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet: function (facilityId, startYear, endYear, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet', 'facilityId', facilityId);
                            // verify required parameter 'startYear' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet', 'startYear', startYear);
                            // verify required parameter 'endYear' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet', 'endYear', endYear);
                            localVarPath = "/facilities/{facility_id}/holidays/schedule"
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (startYear !== undefined) {
                                localVarQueryParameter['start_year'] = startYear;
                            }
                            if (endYear !== undefined) {
                                localVarQueryParameter['end_year'] = endYear;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Standard Holiday Schedule
         * @param {number} startYear
         * @param {number} endYear
         * @param {Set<StandardHolidays>} [standardHolidayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet: function (startYear, endYear, standardHolidayName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'startYear' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet', 'startYear', startYear);
                            // verify required parameter 'endYear' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet', 'endYear', endYear);
                            localVarPath = "/facilities/standard-holidays/schedule";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (startYear !== undefined) {
                                localVarQueryParameter['start_year'] = startYear;
                            }
                            if (endYear !== undefined) {
                                localVarQueryParameter['end_year'] = endYear;
                            }
                            if (standardHolidayName) {
                                localVarQueryParameter['standard_holiday_name'] = Array.from(standardHolidayName);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a facility holiday by a given id.
         * @summary Update Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {UpdateFacilityHoliday} updateFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut: function (holidayId, facilityId, updateFacilityHoliday, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'holidayId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut', 'holidayId', holidayId);
                            // verify required parameter 'facilityId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut', 'facilityId', facilityId);
                            // verify required parameter 'updateFacilityHoliday' is not null or undefined
                            (0, common_1.assertParamExists)('updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut', 'updateFacilityHoliday', updateFacilityHoliday);
                            localVarPath = "/facilities/{facility_id}/holidays/{holiday_id}"
                                .replace("{".concat("holiday_id", "}"), encodeURIComponent(String(holidayId)))
                                .replace("{".concat("facility_id", "}"), encodeURIComponent(String(facilityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFacilityHoliday, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.HolidaysApiAxiosParamCreator = HolidaysApiAxiosParamCreator;
/**
 * HolidaysApi - functional programming interface
 * @export
 */
var HolidaysApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HolidaysApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a holiday at a facility.
         * @summary Create Facility Holiday
         * @param {string} facilityId
         * @param {CreateFacilityHoliday} createFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityHolidayFacilitiesFacilityIdHolidaysPost: function (facilityId, createFacilityHoliday, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFacilityHolidayFacilitiesFacilityIdHolidaysPost(facilityId, createFacilityHoliday, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a holiday at a specified facility.
         * @summary Delete Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete: function (holidayId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete(holidayId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a list of facility holidays at a specified facility.
         * @summary List Facility Holidays
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityHolidaysFacilitiesFacilityIdHolidaysGet: function (facilityId, page, limit, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFacilityHolidaysFacilitiesFacilityIdHolidaysGet(facilityId, page, limit, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a facility holiday at a specified facility by a given id.
         * @summary Retrieve Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet: function (holidayId, facilityId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet(holidayId, facilityId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve a schedule of the holidays at a Facility for a given range of years
         * @summary Retrieve Facility Holiday Schedule
         * @param {string} facilityId
         * @param {number} startYear
         * @param {number} endYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet: function (facilityId, startYear, endYear, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet(facilityId, startYear, endYear, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Standard Holiday Schedule
         * @param {number} startYear
         * @param {number} endYear
         * @param {Set<StandardHolidays>} [standardHolidayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet: function (startYear, endYear, standardHolidayName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet(startYear, endYear, standardHolidayName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update a facility holiday by a given id.
         * @summary Update Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {UpdateFacilityHoliday} updateFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut: function (holidayId, facilityId, updateFacilityHoliday, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut(holidayId, facilityId, updateFacilityHoliday, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HolidaysApiFp = HolidaysApiFp;
/**
 * HolidaysApi - factory interface
 * @export
 */
var HolidaysApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HolidaysApiFp)(configuration);
    return {
        /**
         * Create a holiday at a facility.
         * @summary Create Facility Holiday
         * @param {string} facilityId
         * @param {CreateFacilityHoliday} createFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilityHolidayFacilitiesFacilityIdHolidaysPost: function (facilityId, createFacilityHoliday, options) {
            return localVarFp.createFacilityHolidayFacilitiesFacilityIdHolidaysPost(facilityId, createFacilityHoliday, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a holiday at a specified facility.
         * @summary Delete Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete: function (holidayId, facilityId, options) {
            return localVarFp.deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete(holidayId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of facility holidays at a specified facility.
         * @summary List Facility Holidays
         * @param {string} facilityId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilityHolidaysFacilitiesFacilityIdHolidaysGet: function (facilityId, page, limit, sort, options) {
            return localVarFp.listFacilityHolidaysFacilitiesFacilityIdHolidaysGet(facilityId, page, limit, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a facility holiday at a specified facility by a given id.
         * @summary Retrieve Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet: function (holidayId, facilityId, options) {
            return localVarFp.retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet(holidayId, facilityId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve a schedule of the holidays at a Facility for a given range of years
         * @summary Retrieve Facility Holiday Schedule
         * @param {string} facilityId
         * @param {number} startYear
         * @param {number} endYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet: function (facilityId, startYear, endYear, options) {
            return localVarFp.retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet(facilityId, startYear, endYear, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve Standard Holiday Schedule
         * @param {number} startYear
         * @param {number} endYear
         * @param {Set<StandardHolidays>} [standardHolidayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet: function (startYear, endYear, standardHolidayName, options) {
            return localVarFp.retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet(startYear, endYear, standardHolidayName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a facility holiday by a given id.
         * @summary Update Facility Holiday
         * @param {string} holidayId
         * @param {string} facilityId
         * @param {UpdateFacilityHoliday} updateFacilityHoliday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut: function (holidayId, facilityId, updateFacilityHoliday, options) {
            return localVarFp.updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut(holidayId, facilityId, updateFacilityHoliday, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HolidaysApiFactory = HolidaysApiFactory;
/**
 * HolidaysApi - object-oriented interface
 * @export
 * @class HolidaysApi
 * @extends {BaseAPI}
 */
var HolidaysApi = /** @class */ (function (_super) {
    __extends(HolidaysApi, _super);
    function HolidaysApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a holiday at a facility.
     * @summary Create Facility Holiday
     * @param {string} facilityId
     * @param {CreateFacilityHoliday} createFacilityHoliday
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidaysApi
     */
    HolidaysApi.prototype.createFacilityHolidayFacilitiesFacilityIdHolidaysPost = function (facilityId, createFacilityHoliday, options) {
        var _this = this;
        return (0, exports.HolidaysApiFp)(this.configuration).createFacilityHolidayFacilitiesFacilityIdHolidaysPost(facilityId, createFacilityHoliday, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a holiday at a specified facility.
     * @summary Delete Facility Holiday
     * @param {string} holidayId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidaysApi
     */
    HolidaysApi.prototype.deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete = function (holidayId, facilityId, options) {
        var _this = this;
        return (0, exports.HolidaysApiFp)(this.configuration).deleteFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdDelete(holidayId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of facility holidays at a specified facility.
     * @summary List Facility Holidays
     * @param {string} facilityId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidaysApi
     */
    HolidaysApi.prototype.listFacilityHolidaysFacilitiesFacilityIdHolidaysGet = function (facilityId, page, limit, sort, options) {
        var _this = this;
        return (0, exports.HolidaysApiFp)(this.configuration).listFacilityHolidaysFacilitiesFacilityIdHolidaysGet(facilityId, page, limit, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a facility holiday at a specified facility by a given id.
     * @summary Retrieve Facility Holiday
     * @param {string} holidayId
     * @param {string} facilityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidaysApi
     */
    HolidaysApi.prototype.retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet = function (holidayId, facilityId, options) {
        var _this = this;
        return (0, exports.HolidaysApiFp)(this.configuration).retrieveFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdGet(holidayId, facilityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve a schedule of the holidays at a Facility for a given range of years
     * @summary Retrieve Facility Holiday Schedule
     * @param {string} facilityId
     * @param {number} startYear
     * @param {number} endYear
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidaysApi
     */
    HolidaysApi.prototype.retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet = function (facilityId, startYear, endYear, options) {
        var _this = this;
        return (0, exports.HolidaysApiFp)(this.configuration).retrieveFacilityHolidayScheduleFacilitiesFacilityIdHolidaysScheduleGet(facilityId, startYear, endYear, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve Standard Holiday Schedule
     * @param {number} startYear
     * @param {number} endYear
     * @param {Set<StandardHolidays>} [standardHolidayName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidaysApi
     */
    HolidaysApi.prototype.retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet = function (startYear, endYear, standardHolidayName, options) {
        var _this = this;
        return (0, exports.HolidaysApiFp)(this.configuration).retrieveStandardHolidayScheduleFacilitiesStandardHolidaysScheduleGet(startYear, endYear, standardHolidayName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a facility holiday by a given id.
     * @summary Update Facility Holiday
     * @param {string} holidayId
     * @param {string} facilityId
     * @param {UpdateFacilityHoliday} updateFacilityHoliday
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidaysApi
     */
    HolidaysApi.prototype.updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut = function (holidayId, facilityId, updateFacilityHoliday, options) {
        var _this = this;
        return (0, exports.HolidaysApiFp)(this.configuration).updateFacilityHolidayFacilitiesFacilityIdHolidaysHolidayIdPut(holidayId, facilityId, updateFacilityHoliday, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HolidaysApi;
}(base_1.BaseAPI));
exports.HolidaysApi = HolidaysApi;
/**
 * ShipwellUiApi - axios parameter creator
 * @export
 */
var ShipwellUiApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Derive information about the authenticated persona with regard to dock scheduling
         * @summary Get Persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonaFacilitiesShipwellUiPersonaGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/facilities/shipwell-ui/persona";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Parse the `custom_data` belonging to a Shipment Stop to determine if it contains a special \"planned window\" workaround field value that an be used for availability calculation. Or if no such custom field is available, potentially calculate a single-day planned window based of the Stop\'s provided `planned_date`.
         * @summary Stop Planned Window Custom Field
         * @param {StopCustomDataRequest} stopCustomDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopPlannedWindowCustomFieldFacilitiesShipwellUiStopPlannedWindowCustomFieldPost: function (stopCustomDataRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'stopCustomDataRequest' is not null or undefined
                            (0, common_1.assertParamExists)('stopPlannedWindowCustomFieldFacilitiesShipwellUiStopPlannedWindowCustomFieldPost', 'stopCustomDataRequest', stopCustomDataRequest);
                            localVarPath = "/facilities/shipwell-ui/stop-planned-window-custom-field";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stopCustomDataRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShipwellUiApiAxiosParamCreator = ShipwellUiApiAxiosParamCreator;
/**
 * ShipwellUiApi - functional programming interface
 * @export
 */
var ShipwellUiApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShipwellUiApiAxiosParamCreator)(configuration);
    return {
        /**
         * Derive information about the authenticated persona with regard to dock scheduling
         * @summary Get Persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonaFacilitiesShipwellUiPersonaGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPersonaFacilitiesShipwellUiPersonaGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Parse the `custom_data` belonging to a Shipment Stop to determine if it contains a special \"planned window\" workaround field value that an be used for availability calculation. Or if no such custom field is available, potentially calculate a single-day planned window based of the Stop\'s provided `planned_date`.
         * @summary Stop Planned Window Custom Field
         * @param {StopCustomDataRequest} stopCustomDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopPlannedWindowCustomFieldFacilitiesShipwellUiStopPlannedWindowCustomFieldPost: function (stopCustomDataRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stopPlannedWindowCustomFieldFacilitiesShipwellUiStopPlannedWindowCustomFieldPost(stopCustomDataRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShipwellUiApiFp = ShipwellUiApiFp;
/**
 * ShipwellUiApi - factory interface
 * @export
 */
var ShipwellUiApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShipwellUiApiFp)(configuration);
    return {
        /**
         * Derive information about the authenticated persona with regard to dock scheduling
         * @summary Get Persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonaFacilitiesShipwellUiPersonaGet: function (options) {
            return localVarFp.getPersonaFacilitiesShipwellUiPersonaGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Parse the `custom_data` belonging to a Shipment Stop to determine if it contains a special \"planned window\" workaround field value that an be used for availability calculation. Or if no such custom field is available, potentially calculate a single-day planned window based of the Stop\'s provided `planned_date`.
         * @summary Stop Planned Window Custom Field
         * @param {StopCustomDataRequest} stopCustomDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopPlannedWindowCustomFieldFacilitiesShipwellUiStopPlannedWindowCustomFieldPost: function (stopCustomDataRequest, options) {
            return localVarFp.stopPlannedWindowCustomFieldFacilitiesShipwellUiStopPlannedWindowCustomFieldPost(stopCustomDataRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShipwellUiApiFactory = ShipwellUiApiFactory;
/**
 * ShipwellUiApi - object-oriented interface
 * @export
 * @class ShipwellUiApi
 * @extends {BaseAPI}
 */
var ShipwellUiApi = /** @class */ (function (_super) {
    __extends(ShipwellUiApi, _super);
    function ShipwellUiApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Derive information about the authenticated persona with regard to dock scheduling
     * @summary Get Persona
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.getPersonaFacilitiesShipwellUiPersonaGet = function (options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).getPersonaFacilitiesShipwellUiPersonaGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Parse the `custom_data` belonging to a Shipment Stop to determine if it contains a special \"planned window\" workaround field value that an be used for availability calculation. Or if no such custom field is available, potentially calculate a single-day planned window based of the Stop\'s provided `planned_date`.
     * @summary Stop Planned Window Custom Field
     * @param {StopCustomDataRequest} stopCustomDataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.stopPlannedWindowCustomFieldFacilitiesShipwellUiStopPlannedWindowCustomFieldPost = function (stopCustomDataRequest, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).stopPlannedWindowCustomFieldFacilitiesShipwellUiStopPlannedWindowCustomFieldPost(stopCustomDataRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShipwellUiApi;
}(base_1.BaseAPI));
exports.ShipwellUiApi = ShipwellUiApi;
